// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./svg/arrow-next.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.m-0 {
  margin: 0 !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.mb-25 {
  margin-bottom: 25px !important;
}

.mt-25 {
  margin-top: 25px !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-4 {
  padding-bottom: 15px !important;
}

.pr-15 {
  padding-right: 15px !important;
}

.pr-24 {
  padding-right: 24px !important;
}

.pr-35 {
  padding-right: 35px !important;
}

.w-100 {
  width: 100% !important;
}

.h-100 {
  height: 100% !important;
}

.fw-bold {
  font-weight: bold !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-center {
  text-align: center !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.end-0 {
  right: 0 !important;
}

.d-flex {
  display: flex !important;
}

.flex-column {
  flex-direction: column !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.d-grid {
  display: grid !important;
}

.d-none {
  display: none !important;
}

input::placeholder,
textarea::placeholder {
  font-size: 12px;
  line-height: 18px;
  color: #7a7a9d;
}

input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px rgb(250, 250, 251) inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

textarea::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
textarea::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
textarea::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
textarea::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.form-control-item {
  width: 100%;
  position: relative;
}
.form-control-item > label {
  font-size: 10px;
  line-height: 12px;
  font-weight: 500;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #000000;
  margin-bottom: 8px;
  padding-right: 17px;
}
.form-control-item .error-input fieldset {
  border-color: #f24f52 !important;
}
.form-control-item.checkbox-input {
  margin-top: 6px;
  margin-left: 0;
  margin-right: 0;
  display: flex;
  flex-direction: row;
}
.form-control-item.checkbox-input .checkbox-label {
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  line-height: 18px;
  color: #333333;
  letter-spacing: 0;
  text-transform: none;
  margin-bottom: 0;
  padding-right: 0;
}
.form-control-item.radio-buttons {
  margin-top: 20px;
}
.form-control-item.radio-buttons .radio-buttons-group {
  background: #fafafb;
  border-radius: 5px;
}
.form-control-item.radio-buttons .radio-buttons-group__label {
  font-size: 12px;
  line-height: 20px;
  margin: 0;
  padding: 11px;
  border: 1px solid #ffffff;
}
.form-control-item.textarea-input fieldset {
  border: 1px solid #d0d6e5;
  border-radius: 5px;
}
.form-control-item.textarea-input .end-adornment {
  font-size: 10px;
  line-height: 12px;
  color: #75899d;
}
.form-control-item.select-input .svg-arrow {
  stroke: #6b7682;
  position: absolute;
  right: 15px;
}
.form-control-item.input-field.no-input-border fieldset {
  border: none !important;
}
.form-control-item.input-field fieldset {
  border: 1px solid #d0d6e5;
  border-radius: 5px;
}
.form-control-item.input-field input {
  padding: 0;
}
.form-control-item.input-field .end-adornment {
  font-size: 12px;
  line-height: 20px;
  color: #75899d;
}
.form-control-item.datepicker {
  width: 100%;
}
.form-control-item.datepicker.with-start-icon input {
  padding-left: 47px;
}
.form-control-item.datepicker.datepicker-border-yellow input {
  border-color: #fdc526 !important;
}
.form-control-item.datepicker input {
  font-size: 12px;
  line-height: 20px;
  color: #000000;
  width: 100%;
  padding: 7px 12px 6px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid #d0d6e5;
  border-radius: 5px;
}
.form-control-item.datepicker input:focus, .form-control-item.datepicker input:active {
  border-color: #3c97aa;
  outline: none !important;
}
.form-control-item.datepicker input:disabled {
  border-color: rgba(208, 214, 229, 0.5);
}
.form-control-item.datepicker .datepicker__clock-icon {
  position: absolute;
  left: 15px;
  bottom: 10px;
}
.form-control-item.datepicker .datepicker__clock-icon.clock-activated path {
  stroke: #42ad7e;
}
.form-control-item.datepicker .datepicker__clock-icon.clock-deactivated path {
  stroke: #f27244;
}
.form-control-item.datepicker .datepicker__calendar-icon {
  position: absolute;
  bottom: 10px;
}
.form-control-item.datepicker .datepicker__calendar-icon.calendar-end {
  right: 13px;
}

.required-field::after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-stroke);
  margin-left: 4px;
}

.attachments-field {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px dashed #3c97aa;
}
.attachments-field-icon {
  margin-bottom: 10px;
}
.attachments-field-support {
  font-size: 12px;
  line-height: 12px;
  color: #75899D;
  margin-top: 12px;
}
.attachments-field-link {
  font-size: 14px;
  line-height: 12px;
  color: #3c97aa;
  text-decoration: underline;
  padding-top: 5px;
}
.attachments-field-desc {
  font-size: 14px;
  line-height: 12px;
  color: #75899D;
}

.select-input-field.secondary {
  min-width: 120px;
}
.select-input-field.secondary svg {
  width: 15px;
  margin-top: -10px;
}
.select-input-field.secondary fieldset {
  border: none;
}
.select-input-field.third {
  padding: 9px 12px;
  box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05), 0 0 1px rgba(12, 26, 75, 0.24);
}
.select-input-field.third svg {
  width: 15px;
}
.select-input-field.third fieldset {
  border: none;
}

.switch-field .switch-label {
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #75899d;
  white-space: nowrap;
  margin-bottom: 0 !important;
}

.selectable-item {
  font-size: 12px;
  text-transform: none;
  color: #4a4a4a;
  padding: 11px 14px 12px;
  border: 1px solid #ededed;
  border-radius: 5px;
  cursor: pointer;
}
.selectable-item:not(:first-child) {
  margin-left: 15px;
}
.selectable-item:hover {
  background-color: #fff;
}
.selectable-item.is-active {
  font-weight: 500;
  color: #4a4a4a;
  border-color: #fdc526;
}

.checkbox-field.checkable-tree-all {
  width: 100%;
  margin: 0;
  padding: 3px 12px 3px 1px;
  background-color: #fafafa;
  box-shadow: 0 0 1px rgba(12, 26, 75, 0.24), 0 3px 8px -1px rgba(50, 50, 71, 0.05);
}
.checkbox-field.checkable-tree-all .checkbox-item {
  width: 16px;
  height: 16px;
  position: relative;
  background-color: #fff !important;
  border-color: #d0d6e5;
  border-radius: 0;
}
.checkbox-field.checkable-tree-all .checkbox-item.item-checked::after {
  content: "";
  width: 6px;
  height: 9px;
  position: absolute;
  top: 50%;
  inset-inline-start: 21.5%;
  display: table;
  background-color: transparent;
  border: 2px solid #3c97aa;
  border-top: 0;
  border-left: 0;
  border-radius: 1px;
  opacity: 1;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
}
.checkbox-field .checkbox-item {
  width: 12px;
  height: 12px;
  position: relative;
  border: 1px solid #3c97aa;
  border-radius: 2px;
}
.checkbox-field .checkbox-item.item-checked::after {
  content: "";
  width: 6px;
  height: 6px;
  background-color: #3c97aa;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.checkbox-field .checkbox-item.item-checked.standard {
  border: 1px solid #75899d;
}
.checkbox-field .checkbox-item.item-checked.standard::after {
  background-color: #f8c71c;
}
.checkbox-field .checkbox-item.item-checked.high {
  border: 1px solid #75899d;
}
.checkbox-field .checkbox-item.item-checked.high::after {
  background-color: #f89b11;
}
.checkbox-field .checkbox-item.item-checked.critical {
  border: 1px solid #75899d;
}
.checkbox-field .checkbox-item.item-checked.critical::after {
  background-color: #f24f52;
}
.checkbox-field .checkbox-item.bigger-checkbox {
  width: 16px;
  height: 16px;
}
.checkbox-field .checkbox-item.bigger-checkbox.item-checked::after {
  width: 8px;
  height: 8px;
}

.toggle-password__btn {
  padding: 0px 8px !important;
}
.toggle-password__btn svg {
  height: 18px;
}

.checkable-tree .ant-tree-switcher {
  order: 4;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.checkable-tree.ant-tree .ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner:after {
  background-color: #3c97aa;
}
.checkable-tree.ant-tree .ant-tree-treenode {
  align-items: center;
  width: 100%;
  padding: 8px 12px;
  position: relative;
}
.checkable-tree.ant-tree .ant-tree-treenode.ant-tree-treenode-checkbox-checked {
  background-color: #fafafa;
}
.checkable-tree.ant-tree .ant-tree-checkbox {
  margin-block-start: 0;
}
.checkable-tree.ant-tree .ant-tree-checkbox:hover .ant-tree-checkbox-inner {
  border-color: #3c97aa;
}
.checkable-tree.ant-tree .ant-tree-checkbox + span {
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  line-height: 16px;
  color: #425466;
  min-height: 16px;
}
.checkable-tree.ant-tree .ant-tree-checkbox .ant-tree-checkbox-inner {
  background-color: #fff !important;
  border-color: #d0d6e5;
  border-radius: 0;
}
.checkable-tree.ant-tree .ant-tree-checkbox .ant-tree-checkbox-inner:after {
  border: 2px solid #3c97aa;
  border-top: 0;
  border-left: 0;
  border-radius: 1px;
}

.ant-tree-treenode-disabled .ant-tree-title {
  color: #75899d;
}

.checked-list__label {
  font-size: 8px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  color: #a8acb7;
}
.checked-list-text {
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #75899d;
  max-width: 300px;
  width: 100%;
  margin-right: 24px;
}

.slider-range {
  max-width: 100px;
  margin: 0 20px;
  padding: 15px 0 16px !important;
}
.slider-range-block {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.react-datepicker-popper {
  z-index: 3 !important;
}

.autocomplete-input fieldset {
  border-radius: 5px;
}

.label-gray {
  color: #808080 !important;
}

.text-field-error {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: #f24f52;
  position: absolute;
  top: calc(100% + 3px);
  left: 0;
}

.react-datepicker__navigation {
  top: 9px;
}
.react-datepicker__header {
  font-family: "Roboto", sans-serif;
  background-color: #fff;
  border-bottom: none;
}
.react-datepicker__header__dropdown {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 7px;
}
.react-datepicker__header .react-datepicker__month-read-view--down-arrow,
.react-datepicker__header .react-datepicker__year-read-view--down-arrow {
  width: 7px;
  height: 7px;
  right: -12px;
  top: 3px;
  border-width: 2px 2px 0 0;
}
.react-datepicker__header .react-datepicker__month-read-view--selected-month {
  font-size: 12px;
  line-height: 12px;
}
.react-datepicker__header .react-datepicker__year-read-view--selected-year {
  font-size: 12px;
  line-height: 12px;
}
.react-datepicker__day-names {
  font-weight: 500;
  margin-top: 7px;
  border-top: 1px solid #ededed;
  border-bottom: 1px solid #ededed;
}
.react-datepicker .react-datepicker__day--selected,
.react-datepicker .react-datepicker__day--in-selecting-range,
.react-datepicker .react-datepicker__day--in-range,
.react-datepicker .react-datepicker__month-text--selected,
.react-datepicker .react-datepicker__month-text--in-selecting-range,
.react-datepicker .react-datepicker__month-text--in-range,
.react-datepicker .react-datepicker__quarter-text--selected,
.react-datepicker .react-datepicker__quarter-text--in-selecting-range,
.react-datepicker .react-datepicker__quarter-text--in-range,
.react-datepicker .react-datepicker__year-text--selected,
.react-datepicker .react-datepicker__year-text--in-selecting-range,
.react-datepicker .react-datepicker__year-text--in-range {
  border-radius: 50%;
}
.react-datepicker .react-datepicker__month-dropdown {
  top: 40px;
  left: 0;
  background-color: #fff;
}
.react-datepicker .react-datepicker__year-dropdown {
  top: 40px;
  left: initial;
  right: 0;
  background-color: #fff;
}
.react-datepicker .react-datepicker__month-option,
.react-datepicker .react-datepicker__year-option {
  position: relative;
}
.react-datepicker .react-datepicker__month-option:hover,
.react-datepicker .react-datepicker__year-option:hover {
  font-weight: 500;
  background-color: transparent;
}
.react-datepicker .react-datepicker__month-option--selected,
.react-datepicker .react-datepicker__year-option--selected {
  width: 7px;
  height: 7px;
  color: transparent;
  top: 50%;
  transform: translateY(-50%);
  background-color: #3c97aa;
  border-radius: 50%;
}
.react-datepicker__time-list {
  /* Handle */
  /* Handle on hover */
}
.react-datepicker__time-list::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.react-datepicker__time-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.react-datepicker__time-list::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.body-rtl .main-location-panel .form-control-item.select-input .svg-arrow {
  left: 15px;
  right: unset;
}
.body-rtl .datepicker-range .daterange-field__calendar-icon {
  right: unset;
  left: 15px;
}
.body-rtl .form-control-item.select-input .svg-arrow {
  right: unset;
  left: 15px;
}

.select-rtl {
  direction: rtl;
}

.limitation-line-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.users-facility-switch {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.users-facility-switch label {
  margin-bottom: 5px;
}
.users-facility-switch-subtext {
  font-size: 8px;
  font-weight: 400;
  color: #ABACB7;
  max-width: 300px;
  width: 100%;
}

.users-toggle {
  margin-top: 5px;
}

.chip-checked-hide,
.menuItem-hide {
  display: none !important;
}

.page-title {
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
  color: #000000;
}
.page-details {
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #75899d;
  margin: 0;
}

.bg-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}
.bg-wrapper img {
  width: 100%;
  height: 100%;
}

.fw-medium {
  font-weight: 500;
}

.btn {
  font-family: "Roboto", sans-serif;
  font-size: 14px !important;
  font-weight: 500;
  line-height: 12px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 12px;
  cursor: pointer;
  width: auto;
  height: 44px;
  border-radius: 0 !important;
}
.btn-width {
  width: 175px;
}
.btn.btn-contained {
  border: none;
  color: #FFFFFF !important;
  background-color: #3C97AA;
}
.btn.btn-contained:hover {
  background-color: #17B5D6;
}
.btn.btn-contained:active {
  background-color: #75899D;
}
.btn.btn-contained:disabled {
  background-color: #82C6D4;
}
.btn.btn-outlined {
  color: #3C97AA;
  text-decoration: none;
  background-color: transparent;
  border: 2px solid #3C97AA;
}
.btn.btn-outlined:hover {
  color: #17B5D6;
  border-color: #17B5D6;
}
.btn.btn-outlined:active {
  color: #75899D;
  border-color: #75899D;
}
.btn.btn-outlined:disabled {
  color: #82C6D4;
  border-color: #82C6D4;
}
.btn.btn-rounded {
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  text-transform: none;
  border-radius: 4px;
}
.btn.btn-with-icon {
  padding: 5px 15px 6px 12px;
  display: flex;
  align-items: center;
}
.btn.btn-with-icon svg {
  margin-right: 10px;
}
.btn.btn-medium {
  height: 35px;
}
.btn-simple {
  cursor: pointer;
}
.btn-extra {
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  line-height: 12px;
  color: #3c97aa !important;
  text-decoration: none;
  background-color: transparent;
  border: none !important;
  cursor: pointer;
}
.btn-extra svg {
  fill: #3c97aa;
}
.btn.btn-alert {
  font-size: 12px;
  font-weight: 600;
  line-height: 12px;
  text-decoration-line: underline;
  text-transform: capitalize;
  color: #ffffff;
  height: 12px;
  margin-left: 11px;
  padding: 0;
}
.btn-icon {
  cursor: pointer;
}
.btn.btn-to-top {
  width: 44px;
  height: 44px;
  position: fixed;
  right: 25px;
  bottom: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-svg {
  stroke: #3C97AA;
  transition: all 0.3s ease-in-out;
}
.icon-svg:hover {
  stroke: #17B5D6;
}
.icon-svg:active {
  stroke: #75899D;
}
.icon-svg:disabled {
  stroke: #82C6D4;
}

.icon-arrow {
  stroke: #6f7983;
}

.search input[type=search]:hover ~ svg {
  fill: #6b7682;
}
.search input[type=search]:focus {
  font-size: 12px;
  line-height: 12px;
  color: #242424;
  background: #fafafb;
  box-shadow: 0 0 1px #6b7682, 0 2px 5px -1px rgba(50, 50, 71, 0.07);
  border-radius: 5px;
}
.search input[type=search]:focus ~ svg {
  fill: #6b7682;
}
.search input[type=search]:disabled ~ svg {
  fill: #6b7682;
}

.arrow-blue {
  stroke: #3C97AA;
}
.arrow-back {
  stroke: #c7cddd;
  transform: rotate(90deg);
}
.arrow-top {
  transform: rotate(180deg);
}

.cursor-pointer {
  cursor: pointer;
}

.separator {
  width: 100%;
  height: 1px;
  background-color: #ededed;
}

.pr-15 {
  padding-right: 15px !important;
}

.pr-35 {
  padding-right: 35px !important;
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

.btn-hover:hover {
  color: #17b5d6;
}

.text-upper {
  text-transform: uppercase;
}

.mt-25 {
  margin-top: 25px;
}

.lightbox-wrapper {
  position: relative;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid transparent;
  cursor: zoom-in;
}

.user-avatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.disabled-button {
  pointer-events: none;
}

.info-item {
  margin-bottom: 8px;
  position: relative;
}
.info-item--label {
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #75899d;
  display: block;
}
.info-item--value {
  font-size: 12px;
  line-height: 14px;
  color: #000000;
  position: relative;
  margin-top: 3px;
  padding: 11px 18px 12px 10px;
  background: #f6f7fa;
  border-radius: 5px;
}
.info-item--value b {
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.055em;
}
.info-item--value p {
  margin-bottom: 0;
}

.modal-charts {
  padding: 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #FFFFFF;
  height: 100vh;
  width: 100%;
  overflow: scroll;
}
.modal-charts::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.modal-charts::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.modal-charts::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.modal-charts::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
.modal-charts .modal__body {
  margin-top: 15px;
}
.modal-window {
  padding: 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #FFFFFF;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.modal-window:active, .modal-window:focus {
  outline: none !important;
}
.modal-window-second {
  padding: 25px 0 0;
}
.modal-window-second .modal__head {
  min-height: 40px;
  margin-bottom: 0;
  position: relative;
}
.modal-window-second .modal__head .close-btn {
  top: 0;
  right: 25px;
}
.modal-window-second .modal__body {
  padding: 35px 51px 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
}
.modal-window-second .modal__body-small {
  padding: 35px 30px 0;
}
.modal-window-second .modal__body-title {
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.25px;
  color: #000000;
  margin-bottom: 35px;
}
.modal-window-second .modal__body-title--extra {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  text-transform: none;
  letter-spacing: 0.5px;
  color: #797f89;
  display: block;
  margin: 25px auto 0;
}
.modal-window-second .modal__body-title .subtitle-text {
  font-size: 18px;
  line-height: 20px;
}
.modal-window-second .modal__body-title--extra-info {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #797f89;
  margin-top: 20px;
}
.modal-window-second .modal__body .confirm-text {
  font-size: 16px;
  line-height: 21px;
  color: #797f89;
  text-align: center;
}
.modal-window-second .modal__body .confirm-text b {
  color: #4a4a4a;
  font-weight: 500;
}
.modal-window-second .modal__body .confirm-user {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #222222;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 30px;
  padding: 10px 15px;
  border: 1px solid #fdc526;
  border-radius: 5px;
}
.modal-window-second .modal__body .confirm-user img {
  width: 32px;
  height: 32px;
  margin-right: 20px;
  border: 1px solid #dde0e9;
  border-radius: 50%;
}
.modal-window-second .modal__body .form-control-item > label {
  display: block;
  margin-bottom: 8px;
}
.modal-window-second .modal__footer {
  padding: 0 51px 35px;
  display: flex;
  flex-direction: column;
}
.modal-window-second .modal__footer .btn-cancel {
  text-transform: uppercase;
}
.modal-window-second .modal__footer .btn-confirm {
  margin-bottom: 20px;
}
.modal-window-auto {
  width: auto;
  height: auto;
}
.modal-window-big {
  width: 1024px;
  height: 570px;
}
@media (max-width: 1025px) {
  .modal-window-big.completion-report-modal {
    width: 100%;
    max-height: 500px;
    overflow-x: scroll;
  }
}
.modal-window-medium {
  width: 720px;
  height: 510px;
}
.modal-window-medium-special {
  width: 696px;
  height: 447px;
  padding-top: 20px;
}
.modal-window-medium-special .modal__head-title {
  line-height: 21px;
}
.modal-window-medium-special .modal__head.simple-head {
  padding-bottom: 22px;
}
.modal-window-medium-special .modal__head.simple-head::before {
  width: calc(100% + 50px);
  left: -25px;
  right: -25px;
}
.modal-window-medium-special .modal__head.simple-head::after {
  left: -25px;
}
@media (max-width: 701px) {
  .modal-window-medium.sensor-replace {
    width: 100%;
    height: auto;
  }
}
@media (max-width: 500px) {
  .modal-window-medium.create-ai .modal__body {
    overflow-x: scroll;
  }
}
@media (max-width: 701px) {
  .modal-window-medium.create-ai {
    width: 100%;
    height: auto;
  }
}
.modal-window-small {
  width: 372px;
  height: 464px;
}
@media (max-width: 372px) {
  .modal-window-small {
    width: 100%;
  }
}
.modal-window-confirm {
  width: 375px;
  height: 465px;
}
@media (max-width: 375px) {
  .modal-window-confirm {
    width: 100%;
  }
}
.modal-window .modal-extra-line {
  background-color: #fafafb;
  margin-left: -24px;
  margin-right: -24px;
  padding: 11px 25px 12px;
  border-top: 1px solid #dde0e9;
  border-bottom: 1px solid #dde0e9;
}
.modal-window .modal-extra-line span {
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  color: #6f7b87;
  display: block;
}
.modal-window .modal-extra-line span .btn-extra {
  top: 10px;
}
.modal-window .btn-next {
  width: 160px;
}
.modal__head {
  position: relative;
  margin-bottom: 17px;
}
.modal__head-title {
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
  text-transform: uppercase;
  color: #000000;
  display: flex;
  align-items: center;
}
@media (max-width: 500px) {
  .modal__head-title {
    flex-direction: column;
    align-items: start;
  }
}
@media (max-width: 500px) {
  .modal__head-title .progress-bar-block {
    margin-left: 0;
  }
}
.modal__head-description {
  font-size: 12px;
  line-height: 18px;
  color: #c7cddd;
}
.modal__head-extra {
  font-size: 12px;
  line-height: 24px;
  color: #797f89;
  margin: 20px -25px 0;
  padding: 10px 28px;
  background-color: #fafafb;
  border-top: 1px solid #dde0e9;
  border-bottom: 1px solid #dde0e9;
}
.modal__head.simple-head {
  position: relative;
}
.modal__head.simple-head::before {
  content: "";
  width: 100%;
  height: 1px;
  background-color: #ececec;
  position: absolute;
  left: 0;
  bottom: 0;
}
.modal__head.simple-head::after {
  content: "";
  width: 42px;
  height: 3px;
  background-color: #fcc201;
  position: absolute;
  left: 0;
  bottom: -1.5px;
}
.modal__head .close-btn {
  position: absolute;
  top: 0;
  right: 0;
}
.modal-form-steps {
  background-color: #fafafb;
  margin-left: -24px;
  margin-right: -24px;
  padding: 12px 25px;
  border-top: 1px solid #dde0e9;
  border-bottom: 1px solid #dde0e9;
}
.modal-form-steps .step-name-item {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6f7b87;
  position: relative;
  cursor: pointer;
}
.modal-form-steps .step-name-item:not(:last-child) {
  margin-right: 15px;
  padding-right: 18px;
}
.modal-form-steps .step-name-item.is-active {
  font-size: 12px;
  font-weight: 500;
  color: #4a4a4a;
  cursor: auto;
}
.modal-form-steps .step-name-item .arrow-next {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}
.modal__body {
  flex: 1;
  height: 100%;
}
.modal__footer {
  margin-top: 30px;
}
.modal-step {
  height: 100%;
  padding-top: 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.modal-step .step-title {
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
  text-transform: uppercase;
  margin-top: 20px;
}
.modal-step .form-step__footer {
  flex: 0 0 45px;
}
.modal-step .form-step__footer .btn:last-child {
  margin-left: 25px;
}

.scroll-y {
  overflow-y: scroll;
}

.extra-block {
  padding: 12px 0;
  border-top: 1px solid #ededed;
}
.extra-block span > svg {
  margin-left: 6px;
}

.block__title {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #75899d;
  margin-bottom: 7px;
}
.block__title.no-title {
  min-height: 12px;
}

.ai__title {
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: #FFFFFF;
  max-width: 360px;
  margin-left: -25px;
  margin-right: 20px;
  padding: 6px 25px;
  text-transform: uppercase;
}
.ai__title.font-smaller {
  font-size: 13px;
  line-height: 16px;
}
.ai__title.title-1 {
  background-color: #F8C71C;
}
.ai__title.title-2 {
  background-color: #F9845A;
}
.ai__title.title-3 {
  background-color: #F24F52;
}

.btn-block-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.btn-block-end .btn {
  margin-left: 26px;
}
.btn-block-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-block-between .btn {
  margin-left: 26px;
}

.pos-tr {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.not-change {
  pointer-events: none;
}
.not-change label {
  color: #75899d;
}
.not-change input {
  color: #75899d !important;
}

.body-extra-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 25px;
  background: #fdfdfd;
  box-shadow: 0 0 1px rgba(12, 26, 75, 0.24);
}
@media (max-width: 1366px) {
  .body-extra-panel__right {
    flex-wrap: wrap;
  }
}
@media (max-width: 992px) {
  .body-extra-panel__right .btn-extra {
    padding-top: 20px;
  }
}
@media (max-width: 560px) {
  .body-extra-panel__right .form-control-item,
  .body-extra-panel__right .filter-search {
    width: 99%;
  }
}
@media (max-width: 500px) {
  .body-extra-panel__right {
    flex-direction: column;
  }
}
@media (max-width: 640px) {
  .body-extra-panel {
    justify-content: center;
  }
}
.body-extra-panel .title {
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6f7b87;
}
.body-extra-panel .subtitle {
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.055em;
  font-weight: 500;
  letter-spacing: 0.03em;
  color: #000000;
  margin-top: 3px;
}
.body-extra-panel .page-title {
  flex-shrink: 0;
}
.body-extra-panel.extra-info {
  justify-content: flex-start;
}
.body-extra-panel.extra-info span {
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6f7b87;
}

.start-adornment {
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #75899d;
  white-space: nowrap;
  padding-right: 5px;
}

.page-secondary {
  background-color: #fafafb;
}
.page-secondary__body {
  padding: 25px 25px 0;
  background-color: #fafafb;
}
@media (max-width: 800px) {
  .page-secondary__body {
    height: auto;
  }
}
.page-secondary__body-left {
  padding-right: 1px;
  display: grid;
  grid-row-gap: 25px;
}
.page-secondary__body.page-secondary-print {
  display: block;
}
.page-secondary__body .grid-block {
  padding: 1px;
}
.page-secondary__body .grid-block-container {
  padding: 25px;
  height: 100%;
  background-color: #FFFFFF;
  box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05);
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
}
.page-secondary__footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 25px;
  background-color: #fafafb;
}
.page-secondary__footer .btn {
  width: 100%;
  max-width: 195px;
  border-radius: 0;
}
.page-secondary__footer .btn:not(:first-child) {
  margin-left: 25px;
}

.text-right {
  text-align: right;
}

.swiper-button-next, .swiper-button-prev {
  height: 100%;
}
.swiper-button-next::after, .swiper-button-prev::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center no-repeat;
  background-size: 8px;
  width: 8px;
  height: 10px;
  z-index: 999;
}
.swiper-button-next {
  right: -10px;
}
.swiper-button-prev {
  left: -10px;
}
.swiper-button-prev::after {
  transform: rotate(180deg);
}

.empty-locations-block {
  width: 100%;
  height: 100%;
  max-height: 320px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fbfbfb;
  box-shadow: 0 0 1px rgba(12, 26, 75, 0.24);
}
.empty-locations-block-hide {
  display: none;
}
.empty-locations-block p {
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #75899d;
  margin-bottom: 20px;
}
.empty-locations-block span {
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #797f89;
  max-width: 210px;
}

.checked-list__info {
  padding-top: 18px;
  padding-bottom: 20px;
}
.checked-list__info .selected {
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #75899d;
}

.close-fullscreen-chart {
  margin-left: 5px;
}

.table-infinity-scroll {
  position: relative;
}
.table-infinity-scroll .table-total-after {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6f7b87;
  position: absolute;
  left: 0;
  bottom: -40px;
}

.attachments-image img {
  width: 100% !important;
  height: 100%;
  object-fit: contain;
}

.button-block {
  display: flex;
}

.translates-btn {
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  position: absolute;
  top: -7px;
  right: 15px;
}
@media (max-width: 810px) {
  .translates-btn {
    top: 0;
  }
}
.translates-btn.translates-text-btn {
  position: relative;
  right: 0;
}
@media (max-width: 810px) {
  .translates-btn svg {
    width: 18px;
  }
}
.translates-btn.report-translates-field {
  font-size: 10px;
  line-height: 10px;
  top: 12px;
  right: 0;
}
.translates-btn.report-translates-field svg {
  width: 20px;
}
.translates-btn.report-translates-field .btn-extra {
  margin-left: 5px;
}
.translates-btn .btn-extra {
  margin-left: 10px;
}
@media (max-width: 1281px) {
  .translates-btn .btn-extra {
    font-size: 10px;
    margin-left: 5px;
  }
}

.not-click {
  cursor: auto;
  pointer-events: none;
}

.recently-viewed-mark {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: #b6bbc7;
}

.datepicker-with-time {
  width: 330px;
}
.datepicker-with-time .react-datepicker__time-list::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.datepicker-with-time .react-datepicker__time-list::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.datepicker-with-time .react-datepicker__time-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.datepicker-with-time .react-datepicker__time-list::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.btn-link.support-link {
  font-size: 16px;
  font-weight: 500;
  color: #3694a8;
  text-decoration: none;
}

.header-troubleshooting-icon {
  position: absolute;
  top: -6px;
  right: -6px;
}

.treeselect-field.filter-treeselect {
  flex-direction: row;
  align-items: center;
  padding: 0;
  background: #f6f7fa;
}
.treeselect-field.filter-treeselect label {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: #75899d;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 0;
  padding-left: 14px;
}
.treeselect-field.filter-treeselect .ant-select.ant-select-focused .ant-select-selector {
  box-shadow: none !important;
}
.treeselect-field.filter-treeselect .ant-select-selector {
  height: 35px;
  padding: 12px 0 11px;
  background-color: transparent;
  border: none !important;
  box-shadow: none !important;
}
.treeselect-field.filter-treeselect .ant-select-selector .ant-select-selection-item {
  font-family: "Roboto", sans-serif;
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
  color: #000;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding-inline-end: 20px !important;
}
.treeselect-field.filter-treeselect .ant-select-arrow {
  inset-inline-end: 12px;
}
.treeselect-field.filter-treeselect.select-location .ant-tree-select {
  max-width: 160px;
}
.treeselect-field__list {
  padding-top: 0;
  padding-bottom: 0;
  padding-right: 0;
  border-radius: 0;
  box-shadow: none;
  filter: drop-shadow(0px 3px 8px rgba(50, 50, 71, 0.05)) drop-shadow(0px 0px 1px rgba(12, 26, 75, 0.24));
}
.treeselect-field__list .ant-select-tree-treenode {
  width: 100%;
  align-items: center !important;
  padding-right: 17px !important;
}
.treeselect-field__list .ant-select-tree-treenode .ant-select-tree-switcher {
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.treeselect-field__list .ant-select-tree-treenode .ant-select-tree-indent-unit {
  width: 20px;
}
.treeselect-field__list .ant-select-tree-node-content-wrapper {
  font-family: "Roboto", sans-serif !important;
  font-size: 10px;
  line-height: 12px !important;
  color: #6b7682 !important;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  position: relative;
  min-height: 12px !important;
  padding: 14px 0 12px !important;
}
.treeselect-field__list .ant-select-tree-node-content-wrapper:hover {
  background-color: transparent !important;
}
.treeselect-field__list .ant-select-tree-node-content-wrapper::after {
  content: "";
  width: 100%;
  height: 1px;
  background-color: rgba(171, 191, 210, 0.5);
  position: absolute;
  bottom: 0;
  left: 0px;
}
.treeselect-field__list .ant-select-tree-node-selected {
  font-weight: 600;
  color: #242424 !important;
  background-color: transparent !important;
}
.treeselect-field__list .ant-select-tree-list-scrollbar-thumb {
  width: 6px !important;
  background-color: rgba(0, 0, 0, 0.2) !important;
}

.body-rtl .start-adornment {
  padding-right: 14px;
}
.body-rtl .modal__head-title {
  direction: rtl;
}
.body-rtl .modal__head .close-btn {
  left: 0;
  right: unset;
}
.body-rtl .btn-block-end .btn {
  margin-right: 26px;
  margin-left: 0;
}

.body-rtl {
  direction: rtl;
}
.body-rtl .view,
.body-rtl .table-view,
.body-rtl .root-view {
  margin-right: 0 !important;
  margin-left: -15px !important;
  -webkit-overflow-scrolling: auto !important;
}
.body-rtl .type-label-1 {
  border-right: 4px solid #F4DA62;
  border-left: none;
}
.body-rtl .type-label-1:hover::after {
  right: -11px;
  left: unset;
}
.body-rtl .type-label-2 {
  border-right: 4px solid #F48E62;
  border-left: none;
}
.body-rtl .type-label-2:hover::after {
  left: unset;
  right: -21px;
}
.body-rtl .type-label-3 {
  position: relative;
  border-right: 4px solid #B92C2C;
  border-left: none;
}
.body-rtl .type-label-3:hover::after {
  left: unset;
  right: -11px;
}
.body-rtl .type-label-4 {
  border-right: 4px solid #B92C2C;
  border-left: none;
}
.body-rtl .type-label-4:hover::after {
  left: unset;
  right: -11px;
}
.body-rtl .search {
  padding-right: 12px;
  margin-right: 10px;
}
.body-rtl .search-clear {
  right: unset;
  left: 14px;
}
.body-rtl .search.show-search {
  padding-right: 16px;
}
.body-rtl .add-action-item {
  margin-right: 30px;
  margin-left: unset;
}
.body-rtl .type-critical,
.body-rtl .type-standard,
.body-rtl .type-high {
  margin-right: 20px;
  margin-left: 6px;
}
.body-rtl .custom-filter__single-value {
  margin-right: 50px;
}
.body-rtl .company-saving.ps-5 {
  padding-left: unset !important;
  padding-right: 3rem !important;
}
.body-rtl .main-filter .filter-select {
  margin-right: 15px;
  margin-left: unset;
}
.body-rtl.modal-side .modal-content {
  margin-left: unset;
  margin-right: auto;
}
.body-rtl.modal-side .modal-header {
  padding: 30px 30px 20px 20px !important;
}
.body-rtl .main-filter .filter-select .custom-filter__single-value {
  margin-right: 42px;
}
.body-rtl.modal-fullwidth {
  margin-right: 250px;
}
.body-rtl .selection-text {
  margin-right: 10px;
  margin-left: unset;
}
.body-rtl .reports-icon-doc::before,
.body-rtl .reports-icon-file::before {
  right: -29px;
  left: unset;
}
.body-rtl.modal-fullwidth.modal-side {
  margin-left: 0;
  margin-right: auto;
}
.body-rtl.modal-dialog.modal-fullwidth.ai-fullwidth {
  margin-right: 200px;
}
.body-rtl .drawer-view {
  margin-left: -15px;
  margin-right: unset;
}
.body-rtl .form-check-label {
  margin-right: 10px;
}
.body-rtl .profileInfo,
.body-rtl .custom-btn.btn-submit {
  margin-right: 20px;
}
.body-rtl .location-wrapper span {
  right: unset !important;
  left: 0;
}
.body-rtl .input-urgency-1 {
  margin-right: 15px;
}
.body-rtl .input-urgency-2 {
  margin-right: 27px;
}
.body-rtl .info-title {
  padding-right: 30px;
}
.body-rtl .fullscreen-btn {
  right: unset;
  left: 9px;
}
.body-rtl .event-input .form-check-input {
  float: left !important;
}
.body-rtl .charts-btn {
  transform: rotate(180deg);
}
.body-rtl .change-theme-icon {
  transform: rotate(220deg);
  margin-left: 5px;
}
.body-rtl .saving-icon {
  margin-right: 0;
  margin-left: 10px;
}
.body-rtl .saving-block {
  margin-right: 0;
  margin-left: 10px;
}
.body-rtl .filter-item {
  margin-right: 0;
  margin-left: 20px;
}
.body-rtl .comment-controls {
  top: 20px;
  right: 5px;
}
.body-rtl .ai-label {
  margin-right: 10px;
}
.body-rtl .attach-icon {
  margin-right: 0;
  margin-left: 10px;
}
.body-rtl.modal-fullwidth .modal-header {
  padding: 30px 30px 20px 30px !important;
}
.body-rtl .header-close {
  margin-right: 10px;
}
.body-rtl .full-btn {
  margin-right: 0;
}
.body-rtl.modal-fullwidth .advance-search {
  right: unset;
  left: 0;
}

body .add-action-item:hover,
.btn-check:checked + .btn-secondary:focus,
.btn-check:active + .btn-secondary:focus,
.btn-secondary:active:focus,
.btn-secondary.active:focus,
.show > .btn-secondary.dropdown-toggle:focus,
.btn-check:focus + .btn-secondary,
.btn-secondary:focus,
.btn-check:focus + .btn,
.btn:focus {
  box-shadow: none;
}

* {
  font-family: "Roboto", sans-serif;
  box-sizing: border-box;
}

body {
  font-size: 12px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
body::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
body::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
body::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
body .view {
  background-color: #fafafb;
  overflow-y: scroll !important;
}
body .view.onboard {
  position: relative !important;
}
body .page-title {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 1;
}
body .container-block {
  background-color: #f5f5f5;
  padding: 25px;
}
@media (max-width: 800px) {
  body .container-block {
    padding: 25px 15px;
  }
}
body .container-block.full-height {
  min-height: calc(100vh - 170px);
}
body .custom-filter__indicator.custom-filter__dropdown-indicator svg {
  fill: #232732;
}
body .custom-filter__indicator.custom-filter__dropdown-indicator svg path {
  fill: #232732;
}
body .page-title {
  color: #000000;
}

.tooltip {
  background: var(--tables-secondary-row-sub-title-surface);
}
.tooltip span {
  color: var(--title-inputs-sections-title) !important;
}
.tooltip b {
  color: var(--tables-primary-row-text-main);
  fill: var(--tables-primary-row-text-main);
}
.tooltip path {
  fill: var(--tables-secondary-row-sub-title-surface);
}
.tooltip text {
  fill: var(--tables-secondary-row-sub-title-text) !important;
}
.tooltip tspan {
  color: var(--tables-primary-row-text-main);
  fill: var(--tables-primary-row-text-main);
}

.track-margin {
  height: calc(100% - 50px);
  top: 50px;
  right: 3px;
  border-radius: 3px;
}

.link-color {
  color: #3c97aa !important;
}

div.react-tooltip {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  text-align: center;
  text-transform: initial;
  letter-spacing: 0;
  z-index: 9;
}

.disabled-mark {
  width: 6px;
  height: 6px;
  flex-shrink: 0;
  margin-left: 20px;
  background-color: #fdc526;
  border-radius: 50%;
}

.text-lowercase {
  text-transform: lowercase;
}

.tooltip-size-medium {
  max-width: 450px;
}

.empty-block-table {
  position: absolute;
  top: 45px;
  left: 50%;
  transform: translateX(-50%);
}
.empty-block-table span {
  font-size: 12px;
  text-transform: uppercase;
  color: #6f7b87;
  text-align: center;
  padding: 17px 25px;
}

#react-refresh-overlay {
  display: none;
}

.ml-40 {
  margin-left: 40px;
}

:root {
  --blue-neutral-blue-20: #d0e0e9;
  --blue-neutral-blue-30: #c7cddd;
  --blue-neutral-blue-40: #c4c9dd;
  --blue-neutral-blue-50: #a8acb7;
  --blue-neutral-blue-60: #75899d;
  --blue-neutral-blue-70: #797f89;
  --dark-accent-blue-primary: #51d5ff;
  --dark-accent-blue-primary-disable: #799ba8;
  --dark-accent-blue-primary-focused: #1aa8e0;
  --dark-accent-blue-primary-hovered: #30c4ff;
  --dark-accent-blue-secondary: #044154;
  --dark-accent-blue-10: #1d76ca;
  --dark-accent-blue-20: #2f4a5a;
  --dark-accent-bumblebee: #f0d980;
  --dark-accent-green-10: #35b37c;
  --dark-accent-green-20: #3a4f46;
  --dark-accent-orange: #fcb141;
  --dark-accent-papaya-urgency: #f9845a;
  --dark-accent-red-10: #f34b4b;
  --dark-accent-red-20: #5a2f2f;
  --dark-accent-red-5: #461e1e;
  --grey-black: #000000;
  --grey-grey-10: #ededef;
  --grey-grey-100: #181818;
  --grey-grey-15: #cccbcb;
  --grey-grey-20: #b2b2b2;
  --grey-grey-25: #999999;
  --grey-grey-30: #c4c9dd;
  --grey-grey-35: #a8acb7;
  --grey-grey-40: #6b7682;
  --grey-grey-45: #6e7076;
  --grey-grey-5: #e0e2e6;
  --grey-grey-50: #797f89;
  --grey-grey-50-2: #797f8980;
  --grey-grey-55: #4a4a4a;
  --grey-grey-60: #414141;
  --grey-grey-65: #343539;
  --grey-grey-70: #2c2d31;
  --grey-grey-75: #2c2c2c;
  --grey-grey-80: #27282b;
  --grey-grey-85: #262626;
  --grey-grey-90: #222222;
  --grey-grey-95: #1f1f1f;
  --grey-grey-95-2: #1f1f1fcc;
  --light-accent-blue-primary: #3c97aa;
  --light-accent-blue-primary-disabled: #b0bfc3;
  --light-accent-blue-primary-focused: #2b7e8e;
  --light-accent-blue-primary-hover: #50afc0;
  --light-accent-blue-secondary: #ecffff;
  --light-accent-blue-10: #d9eaf7;
  --light-accent-blue-20: #1d76ca;
  --light-accent-bumblebee: #f8c71c;
  --light-accent-green-10: #e3ede9;
  --light-accent-green-20: #42ad7e;
  --light-accent-orange: #f89b11;
  --light-accent-papaya: #ff7300;
  --light-accent-red-10: #f7d9d9;
  --light-accent-red-20: #f24f52;
  --light-accent-red-5: #fff4f4;
  --neutrals-neutral-10: #fcfcfd;
  --neutrals-neutral-100: #d0e0e9;
  --neutrals-neutral-20: #f6f7fa;
  --neutrals-neutral-30: #fafafb;
  --neutrals-neutral-30-1: #fafafbcc;
  --neutrals-neutral-40: #f2f2f2;
  --neutrals-neutral-50: #ececec;
  --neutrals-neutral-60: #e4e4e4;
  --neutrals-neutral-70: #d3d3d3;
  --neutrals-neutral-80: #b6bbc7;
  --neutrals-neutral-90: #dde0e9;
  --neutrals-white: #ffffff;
  --yellow-yellow-100: #fff3d4;
  --yellow-yellow-200: #fee8a8;
  --yellow-yellow-300: #fedc7d;
  --yellow-yellow-400: #fdd151;
  --yellow-yellow-500: #fdc526;
  --yellow-yellow-600: #fcc201;
  --yellow-yellow-700: #b37400;
  --yellow-yellow-80: #fffbf0;
  --yellow-yellow-90: #38362f;
}

:root {
  --inputs-default-icon: var(--neutrals-neutral-80, #b6bbc7);
  --inputs-default-placeholder: var(--neutrals-neutral-80, #b6bbc7);
  --inputs-default-stroke: var(--grey-grey-10, #ededef);
  --inputs-default-surface-default: var(--neutrals-white, #ffffff);
  --inputs-default-text: var(--grey-grey-50, #797f89);
  --inputs-disable-disable-surface: var(--neutrals-neutral-40, #f2f2f2);
  --inputs-disable-icon: var(--neutrals-neutral-80, #b6bbc7);
  --inputs-disable-stroke: var(--neutrals-neutral-30, #fafafb);
  --inputs-disable-text: var(--grey-grey-45, #6e7076);
  --inputs-error-error-surface: var(--neutrals-white, #ffffff);
  --inputs-error-stroke: var(--light-accent-red-20, #f24f52);
  --inputs-error-text: var(--grey-black, #000000);
  --inputs-error-text-helper: var(--light-accent-red-20, #f24f52);
  --inputs-filled-filled-surface: var(--neutrals-white, #ffffff);
  --inputs-filled-icon: var(--neutrals-neutral-80, #b6bbc7);
  --inputs-filled-stroke: var(--neutrals-neutral-80, #b6bbc7);
  --inputs-filled-text: var(--grey-black, #000000);
  --inputs-focus-icon: var(--neutrals-neutral-80, #b6bbc7);
  --inputs-focus-stroke: var(--light-accent-blue-primary, #3c97aa);
  --inputs-focus-surface-focus: var(--neutrals-white, #ffffff);
  --inputs-focus-text: var(--grey-black, #000000);
  --inputs-search-icon: var(--light-accent-blue-primary, #3c97aa);
  --inputs-search-surface-default: var(--neutrals-white, #ffffff);
  --inputs-search-surface-table: var(--neutrals-neutral-30, #fafafb);
  --inputs-search-text-filled: var(--grey-grey-55, #4a4a4a);
  --inputs-search-text-placeholer: var(--blue-neutral-blue-50, #a8acb7);
  --brand-logo: var(--grey-black, #000000);
  --brand-logo-surface: var(--yellow-yellow-600, #fcc201);
  --brand-logo-surface-hover: var(--yellow-yellow-300, #fedc7d);
  --brand-waites: var(--neutrals-white, #ffffff);
  --buttons-disable: var(--light-accent-blue-primary-disabled, #b0bfc3);
  --buttons-disable-2: var(--light-accent-blue-primary-disabled, #b0bfc3);
  --buttons-focused: var(--light-accent-blue-primary-focused, #2b7e8e);
  --buttons-hover: var(--light-accent-blue-primary-hover, #50afc0);
  --buttons-stroke: var(--light-accent-blue-primary, #3c97aa);
  --buttons-surface: var(--light-accent-blue-primary, #3c97aa);
  --buttons-surface-2: var(--light-accent-blue-primary, #3c97aa);
  --buttons-text-additional: var(--grey-black, #000000);
  --buttons-text-primary: var(--neutrals-white, #ffffff);
  --buttons-text-secondary: var(--light-accent-blue-primary, #3c97aa);
  --calendar-day-selected: var(--light-accent-blue-secondary, #ecffff);
  --calendar-stroke: var(--grey-grey-10, #ededef);
  --calendar-surface-row: var(--neutrals-white, #ffffff);
  --calendar-surface-title: var(--neutrals-neutral-30, #fafafb);
  --calendar-text-icon-default: var(--grey-grey-55, #4a4a4a);
  --calendar-text-icon-disable: var(--neutrals-neutral-80, #b6bbc7);
  --calendar-text-icon-selected: var(--light-accent-blue-primary, #3c97aa);
  --context-menu-icon: var(--light-accent-blue-primary, #3c97aa);
  --context-menu-stroke: var(--grey-grey-10, #ededef);
  --context-menu-surface: var(--neutrals-white, #ffffff);
  --context-menu-text: var(--grey-grey-45, #6e7076);
  --header-elevation: var(--neutrals-neutral-30, #fafafb);
  --header-icon-main: var(--blue-neutral-blue-60, #75899d);
  --header-icon-secondary: var(--blue-neutral-blue-70, #797f89);
  --header-search: var(--blue-neutral-blue-50, #a8acb7);
  --header-stroke: var(--grey-grey-10, #ededef);
  --header-surface: var(--neutrals-white, #ffffff);
  --header-title-main: var(--grey-black, #000000);
  --header-title-secondary: var(--blue-neutral-blue-60, #75899d);
  --labels-filled-stroke-archived: var(--neutrals-neutral-80, #b6bbc7);
  --labels-filled-stroke-caution: var(--light-accent-orange, #f89b11);
  --labels-filled-stroke-inactive: var(--neutrals-neutral-100, #d0e0e9);
  --labels-filled-surface-archived: var(--neutrals-neutral-80, #b6bbc7);
  --labels-filled-surface-caution: var(--yellow-yellow-100, #fff3d4);
  --labels-filled-surface-count: var(--neutrals-white, #ffffff);
  --labels-filled-surface-critical: var(--light-accent-red-20, #f24f52);
  --labels-filled-surface-empty: var(--neutrals-neutral-90, #dde0e9);
  --labels-filled-surface-high: var(--light-accent-papaya, #ff7300);
  --labels-filled-surface-inactive: var(--neutrals-white, #ffffff);
  --labels-filled-surface-standard: var(--light-accent-bumblebee, #f8c71c);
  --labels-filled-surface-warning: var(--light-accent-red-10, #f7d9d9);
  --labels-filled-text: var(--neutrals-white, #ffffff);
  --labels-filled-text-archived: var(--neutrals-white, #ffffff);
  --labels-filled-text-reversed-white: var(--neutrals-white, #ffffff);
  --labels-outline-stroke-text-archived: var(--neutrals-neutral-80, #b6bbc7);
  --labels-outline-stroke-text-critical: var(--light-accent-red-20, #f24f52);
  --labels-outline-stroke-text-high: var(--light-accent-papaya, #ff7300);
  --labels-outline-stroke-text-standard: var(--light-accent-bumblebee, #f8c71c);
  --labels-outline-stroke-text-success: var(--light-accent-green-20, #42ad7e);
  --labels-outline-surface: var(--neutrals-white, #ffffff);
  --labels-outline-text-standard: var(--yellow-yellow-700, #b37400);
  --legend-for-header-critical: var(--light-accent-red-20, #f24f52);
  --legend-for-header-high: var(--light-accent-papaya, #ff7300);
  --legend-for-header-inactive: var(--neutrals-white, #ffffff);
  --legend-for-header-inactive-stroke: var(--neutrals-neutral-100, #d0e0e9);
  --legend-for-header-no-ai: var(--light-accent-green-20, #42ad7e);
  --legend-for-header-snoozed: var(--grey-grey-10, #ededef);
  --legend-for-header-snoozed-badge: var(--grey-grey-50, #797f89);
  --legend-for-header-snoozed-badge-stroke: var(--neutrals-white, #ffffff);
  --legend-for-header-standard: var(--light-accent-bumblebee, #f8c71c);
  --legend-for-header-text: var(--grey-grey-55, #4a4a4a);
  --map-stroke: var(--neutrals-neutral-40, #f2f2f2);
  --map-surface-click: var(--light-accent-blue-primary-focused, #2b7e8e);
  --map-surface-default: var(--grey-grey-15, #cccbcb);
  --map-surface-hover: var(--grey-grey-20, #b2b2b2);
  --notifications-error-icon-reversed: var(--neutrals-neutral-40, #f2f2f2);
  --notifications-error-icon-surface: var(--dark-accent-red-10, #f34b4b);
  --notifications-error-stroke: var(--dark-accent-red-10, #f34b4b);
  --notifications-error-surface: var(--light-accent-red-10, #f7d9d9);
  --notifications-error-text: var(--grey-grey-85, #222222);
  --notifications-info-icon-reversed: var(--neutrals-neutral-40, #f2f2f2);
  --notifications-info-icon-surface: var(--dark-accent-blue-10, #1d76ca);
  --notifications-info-stroke: var(--dark-accent-blue-10, #1d76ca);
  --notifications-info-surface: var(--light-accent-blue-10, #d9eaf7);
  --notifications-info-text: var(--grey-grey-85, #222222);
  --notifications-success-icon-reversed: var(--neutrals-neutral-40, #f2f2f2);
  --notifications-success-icon-surface: var(--dark-accent-green-10, #35b37c);
  --notifications-success-stroke: var(--dark-accent-green-10, #35b37c);
  --notifications-success-surface: var(--light-accent-green-10, #e3ede9);
  --notifications-success-text: var(--grey-grey-85, #222222);
  --segments-chips-toggle-icon-reversed: var(--neutrals-white, #ffffff);
  --segments-chips-toggle-stroke-active: var(--light-accent-blue-primary, #3c97aa);
  --segments-chips-toggle-stroke-default: var(--neutrals-neutral-70, #d3d3d3);
  --segments-chips-toggle-surface-active: var(--light-accent-blue-secondary, #ecffff);
  --segments-chips-toggle-surface-default: var(--neutrals-neutral-30, #fafafb);
  --segments-chips-toggle-text-active: var(--light-accent-blue-primary, #3c97aa);
  --segments-chips-toggle-text-default: var(--grey-grey-50, #797f89);
  --selection-controls-checkbox-surface-default: var(--blue-neutral-blue-60, #75899d);
  --selection-controls-checkbox-surface-disable: var(--light-accent-blue-primary-disabled, #b0bfc3);
  --selection-controls-checkbox-text: var(--grey-grey-55, #4a4a4a);
  --selection-controls-checkbox-text-disable: var(--grey-grey-45, #6e7076);
  --selection-controls-radio-surface-default: var(--blue-neutral-blue-60, #75899d);
  --selection-controls-radio-surface-disable: var(--light-accent-blue-primary-disabled, #b0bfc3);
  --selection-controls-radio-text: var(--grey-grey-55, #4a4a4a);
  --selection-controls-radio-text-disable: var(--grey-grey-45, #6e7076);
  --selection-controls-toggle-surface-active: var(--light-accent-green-20, #42ad7e);
  --selection-controls-toggle-surface-default: var(--blue-neutral-blue-60, #75899d);
  --selection-controls-toggle-surface-disable: var(--light-accent-blue-primary-disabled, #b0bfc3);
  --selection-controls-toggle-text: var(--grey-grey-55, #4a4a4a);
  --selection-controls-toggle-text-disable: var(--grey-grey-45, #6e7076);
  --selection-controls-toggle-thumb-active: var(--neutrals-white, #ffffff);
  --side-menu-elevation: var(--grey-grey-80, #262626);
  --side-menu-icon-drop-down: var(--grey-grey-50, #797f89);
  --side-menu-icon-primary: var(--blue-neutral-blue-30, #c7cddd);
  --side-menu-icon-secondary: var(--grey-grey-40, #6b7682);
  --side-menu-name: var(--blue-neutral-blue-20, #d0e0e9);
  --side-menu-stroke: var(--grey-grey-60, #414141);
  --side-menu-surface: var(--grey-grey-70, #2c2d31);
  --side-menu-text-primary: var(--blue-neutral-blue-30, #c7cddd);
  --side-menu-text-secondary: var(--grey-grey-40, #6b7682);
  --tables-main-surface: var(--neutrals-neutral-30, #fafafb);
  --tables-pagination-pagination-active: var(--grey-grey-50, #797f89);
  --tables-pagination-pagination-disabled: var(--light-accent-blue-primary-disabled, #b0bfc3);
  --tables-photo-gallery-icon: var(--grey-grey-45, #6e7076);
  --tables-photo-gallery-pagination-active: var(--light-accent-bumblebee, #f8c71c);
  --tables-photo-gallery-pagination-default: var(--neutrals-neutral-80, #b6bbc7);
  --tables-photo-gallery-surface: var(--neutrals-neutral-30, #fafafb);
  --tables-photo-gallery-surface-arrow: var(--neutrals-neutral-30-1, #fafafbcc);
  --tables-primary-row-icon: var(--grey-grey-50, #797f89);
  --tables-primary-row-stroke: var(--grey-grey-10, #ededef);
  --tables-primary-row-stroke-drag-drop: var(--light-accent-blue-primary, #3c97aa);
  --tables-primary-row-surface-default: var(--neutrals-white, #ffffff);
  --tables-primary-row-surface-drag-drop: var(--light-accent-blue-secondary, #ecffff);
  --tables-primary-row-surface-hover: var(--yellow-yellow-80, #fffbf0);
  --tables-primary-row-surface-selected: var(--neutrals-neutral-40, #f2f2f2);
  --tables-primary-row-text-additional: var(--grey-grey-40, #6b7682);
  --tables-primary-row-text-main: var(--grey-grey-70, #2c2d31);
  --tables-secondary-row-sub-title-icon: var(--grey-grey-45, #6e7076);
  --tables-secondary-row-sub-title-surface: var(--neutrals-neutral-30, #fafafb);
  --tables-secondary-row-sub-title-text: var(--grey-grey-45, #6e7076);
  --tables-title-icon: var(--neutrals-neutral-80, #b6bbc7);
  --tables-title-progress-bar: var(--neutrals-neutral-60, #e4e4e4);
  --tables-title-stroke: var(--neutrals-neutral-90, #dde0e9);
  --tables-title-surface: var(--neutrals-neutral-30, #fafafb);
  --tables-title-text: var(--grey-grey-50, #797f89);
  --tabs-stroke-default: var(--neutrals-neutral-40, #f2f2f2);
  --tabs-surface-active: var(--neutrals-white, #ffffff);
  --tabs-surface-default: var(--neutrals-neutral-40, #f2f2f2);
  --tabs-surface-hover: var(--neutrals-neutral-30, #fafafb);
  --tabs-text-active: var(--grey-grey-80, #262626);
  --tabs-text-default: var(--grey-grey-45, #6e7076);
  --tabs-text-disable: var(--grey-grey-35, #a8acb7);
  --tabs-text-hover: var(--grey-black, #000000);
  --title-inputs-sections-drop-down-count: var(--grey-grey-50, #797f89);
  --title-inputs-sections-required: var(--light-accent-red-20, #f24f52);
  --title-inputs-sections-surface: var(--neutrals-white, #ffffff);
  --title-inputs-sections-title: var(--grey-grey-50, #797f89);
  --errors-and-states-green: var(--light-accent-green-20, #42ad7e);
  --tables-skeleton-element: var(--neutrals-neutral-60, #e4e4e4);
  --tables-skeleton-surface-row-2: var(--neutrals-neutral-50, #ececec);
  /*--GENERATED FROM PLUGIN--*/
  --select-dropdown-box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24),
    0px 3px 8px -1px rgba(50, 50, 71, 0.05);
  --modal-box-shadow: 0px 1px 16px -1px rgba(0, 0, 0, 0.15), 1px 2px 8px -1px rgba(65, 65, 65, 0.4);
  --basic-box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
  --info-block-box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
  --table-box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
  --map-legend-item-background-rgb: 255, 255, 255;
}

.dark {
  --inputs-default-icon: var(--blue-neutral-blue-50, #a8acb7);
  --inputs-default-placeholder: var(--grey-grey-50, #797f89);
  --inputs-default-stroke: var(--grey-grey-65, #343539);
  --inputs-default-surface-default: var(--grey-grey-65, #343539);
  --inputs-default-text: var(--neutrals-neutral-80, #b6bbc7);
  --inputs-disable-disable-surface: var(--grey-grey-80, #27282b);
  --inputs-disable-icon: var(--blue-neutral-blue-50, #a8acb7);
  --inputs-disable-stroke: var(--grey-grey-80, #262626);
  --inputs-disable-text: var(--grey-grey-35, #a8acb7);
  --inputs-error-error-surface: var(--grey-grey-65, #343539);
  --inputs-error-stroke: var(--dark-accent-red-10, #f34b4b);
  --inputs-error-text: var(--neutrals-white, #ffffff);
  --inputs-error-text-helper: var(--dark-accent-red-10, #f34b4b);
  --inputs-filled-filled-surface: var(--grey-grey-65, #343539);
  --inputs-filled-icon: var(--blue-neutral-blue-50, #a8acb7);
  --inputs-filled-stroke: var(--grey-grey-55, #4a4a4a);
  --inputs-filled-text: var(--grey-grey-10, #ededef);
  --inputs-focus-icon: var(--blue-neutral-blue-50, #a8acb7);
  --inputs-focus-stroke: var(--dark-accent-blue-primary, #51d5ff);
  --inputs-focus-surface-focus: var(--grey-grey-65, #343539);
  --inputs-focus-text: var(--neutrals-white, #ffffff);
  --inputs-search-icon: var(--dark-accent-blue-primary, #51d5ff);
  --inputs-search-surface-default: var(--grey-grey-70, #2c2d31);
  --inputs-search-surface-table: var(--grey-grey-80, #27282b);
  --inputs-search-text-filled: var(--grey-grey-5, #e0e2e6);
  --inputs-search-text-placeholer: var(--blue-neutral-blue-50, #a8acb7);
  --brand-logo: var(--grey-black, #000000);
  --brand-logo-surface: var(--yellow-yellow-600, #fcc201);
  --brand-logo-surface-hover: var(--yellow-yellow-300, #fedc7d);
  --brand-waites: var(--neutrals-white, #ffffff);
  --buttons-disable: var(--dark-accent-blue-primary-disable, #799ba8);
  --buttons-disable-2: var(--dark-accent-blue-primary-disable, #799ba8);
  --buttons-focused: var(--dark-accent-blue-primary-focused, #1aa8e0);
  --buttons-hover: var(--dark-accent-blue-primary-hovered, #30c4ff);
  --buttons-stroke: var(--dark-accent-blue-primary, #51d5ff);
  --buttons-surface: var(--dark-accent-blue-primary, #51d5ff);
  --buttons-surface-2: var(--dark-accent-blue-primary, #51d5ff);
  --buttons-text-additional: var(--neutrals-white, #ffffff);
  --buttons-text-primary: var(--grey-black, #000000);
  --buttons-text-secondary: var(--dark-accent-blue-primary, #51d5ff);
  --calendar-day-selected: var(--dark-accent-blue-secondary, #044154);
  --calendar-stroke: var(--grey-grey-60, #414141);
  --calendar-surface-row: var(--grey-grey-70, #2c2d31);
  --calendar-surface-title: var(--grey-grey-90, #1f1f1f);
  --calendar-text-icon-default: var(--grey-grey-5, #e0e2e6);
  --calendar-text-icon-disable: var(--grey-grey-50, #797f89);
  --calendar-text-icon-selected: var(--dark-accent-blue-primary, #51d5ff);
  --context-menu-icon: var(--dark-accent-blue-primary, #51d5ff);
  --context-menu-stroke: var(--grey-grey-60, #414141);
  --context-menu-surface: var(--grey-grey-65, #343539);
  --context-menu-text: var(--neutrals-neutral-60, #e4e4e4);
  --header-elevation: var(--grey-grey-90, #1f1f1f);
  --header-icon-main: var(--blue-neutral-blue-40, #c4c9dd);
  --header-icon-secondary: var(--blue-neutral-blue-50, #a8acb7);
  --header-search: var(--blue-neutral-blue-50, #a8acb7);
  --header-stroke: var(--grey-grey-60, #414141);
  --header-surface: var(--grey-grey-70, #2c2d31);
  --header-title-main: var(--neutrals-white, #ffffff);
  --header-title-secondary: var(--blue-neutral-blue-40, #c4c9dd);
  --labels-filled-stroke-archived: var(--grey-grey-35, #a8acb7);
  --labels-filled-stroke-caution: var(--dark-accent-orange, #fcb141);
  --labels-filled-stroke-inactive: var(--neutrals-neutral-100, #d0e0e9);
  --labels-filled-surface-archived: var(--grey-grey-90, #1f1f1f);
  --labels-filled-surface-caution: var(--yellow-yellow-100, #fff3d4);
  --labels-filled-surface-count: var(--grey-grey-70, #2c2d31);
  --labels-filled-surface-critical: var(--dark-accent-red-10, #f34b4b);
  --labels-filled-surface-empty: var(--grey-grey-40, #6b7682);
  --labels-filled-surface-high: var(--dark-accent-papaya-urgency, #f9845a);
  --labels-filled-surface-inactive: var(--neutrals-white, #ffffff);
  --labels-filled-surface-standard: var(--dark-accent-bumblebee, #f0d980);
  --labels-filled-surface-warning: var(--dark-accent-red-20, #5a2f2f);
  --labels-filled-text: var(--grey-grey-70, #2c2d31);
  --labels-filled-text-archived: var(--grey-grey-35, #a8acb7);
  --labels-filled-text-reversed-white: var(--neutrals-white, #ffffff);
  --labels-outline-stroke-text-archived: var(--grey-grey-35, #a8acb7);
  --labels-outline-stroke-text-critical: var(--dark-accent-red-10, #f34b4b);
  --labels-outline-stroke-text-high: var(--dark-accent-papaya-urgency, #f9845a);
  --labels-outline-stroke-text-standard: var(--dark-accent-bumblebee, #f0d980);
  --labels-outline-stroke-text-success: var(--dark-accent-green-10, #35b37c);
  --labels-outline-surface: var(--grey-grey-70, #2c2d31);
  --labels-outline-text-standard: var(--dark-accent-bumblebee, #f0d980);
  --legend-for-header-critical: var(--light-accent-red-20, #f24f52);
  --legend-for-header-high: var(--dark-accent-papaya-urgency, #f9845a);
  --legend-for-header-inactive: var(--neutrals-white, #ffffff);
  --legend-for-header-inactive-stroke: var(--neutrals-neutral-100, #d0e0e9);
  --legend-for-header-no-ai: var(--dark-accent-green-10, #35b37c);
  --legend-for-header-snoozed: var(--grey-grey-5, #e0e2e6);
  --legend-for-header-snoozed-badge: var(--neutrals-white, #ffffff);
  --legend-for-header-snoozed-badge-stroke: var(--grey-grey-70, #2c2d31);
  --legend-for-header-standard: var(--dark-accent-bumblebee, #f0d980);
  --legend-for-header-text: var(--grey-grey-5, #e0e2e6);
  --map-stroke: var(--grey-grey-60, #414141);
  --map-surface-click: var(--dark-accent-blue-primary-focused, #1aa8e0);
  --map-surface-default: var(--grey-grey-45, #6e7076);
  --map-surface-hover: var(--grey-grey-85, #222222);
  --notifications-error-icon-reversed: var(--neutrals-neutral-40, #f2f2f2);
  --notifications-error-icon-surface: var(--dark-accent-red-10, #f34b4b);
  --notifications-error-stroke: var(--dark-accent-red-10, #f34b4b);
  --notifications-error-surface: var(--dark-accent-red-20, #5a2f2f);
  --notifications-error-text: var(--neutrals-neutral-40, #f2f2f2);
  --notifications-info-icon-reversed: var(--neutrals-neutral-40, #f2f2f2);
  --notifications-info-icon-surface: var(--dark-accent-blue-10, #1d76ca);
  --notifications-info-stroke: var(--dark-accent-blue-10, #1d76ca);
  --notifications-info-surface: var(--dark-accent-blue-20, #2f4a5a);
  --notifications-info-text: var(--neutrals-neutral-40, #f2f2f2);
  --notifications-success-icon-reversed: var(--neutrals-neutral-40, #f2f2f2);
  --notifications-success-icon-surface: var(--dark-accent-green-10, #35b37c);
  --notifications-success-stroke: var(--dark-accent-green-10, #35b37c);
  --notifications-success-surface: var(--dark-accent-green-20, #3a4f46);
  --notifications-success-text: var(--neutrals-neutral-40, #f2f2f2);
  --segments-chips-toggle-icon-reversed: var(--neutrals-white, #ffffff);
  --segments-chips-toggle-stroke-active: var(--dark-accent-blue-primary, #51d5ff);
  --segments-chips-toggle-stroke-default: var(--neutrals-neutral-70, #d3d3d3);
  --segments-chips-toggle-surface-active: var(--dark-accent-blue-secondary, #044154);
  --segments-chips-toggle-surface-default: var(--grey-grey-90, #1f1f1f);
  --segments-chips-toggle-text-active: var(--dark-accent-blue-primary, #51d5ff);
  --segments-chips-toggle-text-default: var(--neutrals-neutral-70, #d3d3d3);
  --selection-controls-checkbox-surface-default: var(--grey-grey-30, #c4c9dd);
  --selection-controls-checkbox-surface-disable: var(--dark-accent-blue-primary-disable, #799ba8);
  --selection-controls-checkbox-text: var(--grey-grey-5, #e0e2e6);
  --selection-controls-checkbox-text-disable: var(--grey-grey-35, #a8acb7);
  --selection-controls-radio-surface-default: var(--grey-grey-30, #c4c9dd);
  --selection-controls-radio-surface-disable: var(--dark-accent-blue-primary-disable, #799ba8);
  --selection-controls-radio-text: var(--grey-grey-5, #e0e2e6);
  --selection-controls-radio-text-disable: var(--grey-grey-35, #a8acb7);
  --selection-controls-toggle-surface-active: var(--dark-accent-green-10, #35b37c);
  --selection-controls-toggle-surface-default: var(--grey-grey-30, #c4c9dd);
  --selection-controls-toggle-surface-disable: var(--dark-accent-blue-primary-disable, #799ba8);
  --selection-controls-toggle-text: var(--grey-grey-5, #e0e2e6);
  --selection-controls-toggle-text-disable: var(--grey-grey-35, #a8acb7);
  --selection-controls-toggle-thumb-active: var(--grey-grey-70, #2c2d31);
  --side-menu-elevation: var(--grey-grey-80, #262626);
  --side-menu-icon-drop-down: var(--grey-grey-50, #797f89);
  --side-menu-icon-primary: var(--blue-neutral-blue-30, #c7cddd);
  --side-menu-icon-secondary: var(--grey-grey-40, #6b7682);
  --side-menu-name: var(--blue-neutral-blue-20, #d0e0e9);
  --side-menu-stroke: var(--grey-grey-60, #414141);
  --side-menu-surface: var(--grey-grey-70, #2c2d31);
  --side-menu-text-primary: var(--blue-neutral-blue-30, #c7cddd);
  --side-menu-text-secondary: var(--grey-grey-40, #6b7682);
  --tables-main-surface: var(--grey-grey-100, #181818);
  --tables-pagination-pagination-active: var(--neutrals-neutral-80, #b6bbc7);
  --tables-pagination-pagination-disabled: var(--dark-accent-blue-primary-disable, #799ba8);
  --tables-photo-gallery-icon: var(--grey-grey-5, #e0e2e6);
  --tables-photo-gallery-pagination-active: var(--dark-accent-bumblebee, #f0d980);
  --tables-photo-gallery-pagination-default: var(--grey-grey-50, #797f89);
  --tables-photo-gallery-surface: var(--grey-grey-80, #262626);
  --tables-photo-gallery-surface-arrow: var(--grey-grey-90-2, #1f1f1fcc);
  --tables-primary-row-icon: var(--grey-grey-5, #e0e2e6);
  --tables-primary-row-stroke: var(--grey-grey-60, #414141);
  --tables-primary-row-stroke-drag-drop: var(--dark-accent-blue-primary, #51d5ff);
  --tables-primary-row-surface-default: var(--grey-grey-70, #2c2d31);
  --tables-primary-row-surface-drag-drop: var(--dark-accent-blue-secondary, #044154);
  --tables-primary-row-surface-hover: var(--yellow-yellow-90, #38362f);
  --tables-primary-row-surface-selected: var(--grey-grey-60, #414141);
  --tables-primary-row-text-additional: var(--grey-grey-50, #797f89);
  --tables-primary-row-text-main: var(--neutrals-neutral-40, #f2f2f2);
  --tables-secondary-row-sub-title-icon: var(--grey-grey-35, #a8acb7);
  --tables-secondary-row-sub-title-surface: var(--grey-grey-85, #222222);
  --tables-secondary-row-sub-title-text: var(--grey-grey-35, #a8acb7);
  --tables-title-icon: var(--grey-grey-45, #6e7076);
  --tables-title-progress-bar: var(--grey-grey-60, #414141);
  --tables-title-stroke: var(--grey-grey-60, #414141);
  --tables-title-surface: var(--grey-grey-80, #262626);
  --tables-title-text: var(--grey-grey-5, #e0e2e6);
  --tabs-stroke-default: var(--grey-grey-80, #262626);
  --tabs-surface-active: var(--grey-grey-65, #343539);
  --tabs-surface-default: var(--grey-grey-80, #27282b);
  --tabs-surface-hover: var(--grey-grey-65, #343539);
  --tabs-text-active: var(--neutrals-white, #ffffff);
  --tabs-text-default: var(--grey-grey-30, #c4c9dd);
  --tabs-text-disable: var(--grey-grey-40, #6b7682);
  --tabs-text-hover: var(--neutrals-neutral-70, #d3d3d3);
  --title-inputs-sections-drop-down-count: var(--blue-neutral-blue-50, #a8acb7);
  --title-inputs-sections-required: var(--dark-accent-red-10, #f34b4b);
  --title-inputs-sections-surface: var(--grey-grey-70, #2c2d31);
  --title-inputs-sections-title: var(--grey-grey-35, #a8acb7);
  --errors-and-states-green: var(--light-accent-green-20, #42ad7e);
  --tables-skeleton-element: var(--grey-grey-60, #414141);
  --tables-skeleton-surface-row-2: var(--grey-grey-55, #4a4a4a);
  /*--GENERATED FROM PLUGIN--*/
  --select-dropdown-box-shadow: 0px 1px 16px -1px rgba(0, 0, 0, 0.15), 1px 2px 8px -1px rgba(65, 65, 65, 0.4);
  --modal-box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
  --basic-box-shadow: 0px 1px 16px -1px rgba(0, 0, 0, 0.15), 1px 2px 8px -1px rgba(65, 65, 65, 0.4);
  --info-block-box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
  --file-preview-item-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
  --table-box-shadow: 0px -1px 0px 0px #414141 inset;
  --map-legend-item-background-rgb: 52, 53, 57;
}`, "",{"version":3,"sources":["webpack://./../src/assets/temporaryBootstrap.scss","webpack://./../src/assets/app.scss","webpack://./../src/assets/_input-fields.scss","webpack://./../src/assets/_mixins.scss","webpack://./../src/assets/_base.scss","webpack://./../src/assets/variables.scss","webpack://./../src/assets/_components.scss","webpack://./../src/assets/rtl.scss","webpack://./../src/assets/main.scss","webpack://./../src/constants/styles/_colors.scss","webpack://./../src/constants/styles/_theme-light.scss","webpack://./../src/constants/styles/_theme-dark.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;ACDF;;ADIA;EACE,6BAAA;ACDF;;ADIA;EACE,+BAAA;EACA,8BAAA;ACDF;;ADIA;EACE,6BAAA;ACDF;;ADIA;EACE,2BAAA;ACDF;;ADIA;EACE,oBAAA;ACDF;;ADIA;EACE,wBAAA;EACA,2BAAA;ACDF;;ADIA;EACE,8BAAA;ACDF;;ADIA;EACE,2BAAA;ACDF;;ADIA;EACE,qBAAA;ACDF;;ADIA;EACE,+BAAA;ACDF;;ADIA;EACE,4BAAA;ACDF;;ADIA;EACE,+BAAA;ACDF;;ADIA;EACE,8BAAA;ACDF;;ADIA;EACE,8BAAA;ACDF;;ADIA;EACE,8BAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,uBAAA;ACDF;;ADIA;EACE,4BAAA;ACDF;;ADIA;EACE,2BAAA;ACDF;;ADIA;EACE,oCAAA;ACDF;;ADIA;EACE,6BAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;ADIA;EACE,2BAAA;ACDF;;ADIA;EACE,mBAAA;ACDF;;ADIA;EACE,wBAAA;ACDF;;ADIA;EACE,iCAAA;ACDF;;ADIA;EACE,yCAAA;ACDF;;ADIA;EACE,oCAAA;ACDF;;ADIA;EACE,kCAAA;ACDF;;ADIA;EACE,8BAAA;ACDF;;ADIA;EACE,gCAAA;ACDF;;ADIA;EACE,+BAAA;ACDF;;ADIA;EACE,wBAAA;ACDF;;ADIA;EACE,wBAAA;ACDF;;ACvIE;;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AD2IJ;;ACrIE;EAEE,wBAAA;EACA,SAAA;ADuIJ;ACpIE;EACE,0BAAA;ADsIJ;;AClIA;;;;;;EAME,yDAAA;EACA,yDAAA;EAAA,iDAAA;ADqIF;;AA3IE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AA8IJ;AA3IE;EACE,+BAAA;EACA,kBAAA;AA6IJ;AA1IE;EACE,8BAAA;EACA,kBAAA;AA4IJ;AAzIE;EACE,gBAAA;EACA,kBAAA;AA2IJ;;AC9IE;EACE,WAAA;EACA,kBAAA;ADiJJ;AC/II;EC3CF,eAAA;EACA,iBAAA;ED4CI,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;ADkJN;AC9IM;EACE,gCAAA;ADgJR;AC5II;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AD8IN;AC5IM;EC7DJ,eAAA;EACA,iBAAA;ED8DM,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;AD+IR;AC3II;EACE,gBAAA;AD6IN;AC3IM;EACE,mBAAA;EACA,kBAAA;AD6IR;AC3IQ;EChFN,eAAA;EACA,iBAAA;EDiFQ,SAAA;EACA,aAAA;EACA,yBAAA;AD8IV;ACxIM;EACE,yBAAA;EACA,kBAAA;AD0IR;ACvIM;ECpGJ,eAAA;EACA,iBAAA;EDqGM,cAAA;AD0IR;ACrIM;EACE,eAAA;EACA,kBAAA;EACA,WAAA;ADuIR;ACjIQ;EACE,uBAAA;ADmIV;AC/HM;EACE,yBAAA;EACA,kBAAA;ADiIR;AC9HM;EACE,UAAA;ADgIR;AC7HM;EC7HJ,eAAA;EACA,iBAAA;ED8HM,cAAA;ADgIR;AC5HI;EACE,WAAA;AD8HN;AC3HQ;EACE,kBAAA;AD6HV;ACxHQ;EACE,gCAAA;AD0HV;ACtHM;EClJJ,eAAA;EACA,iBAAA;EDmJM,cAAA;EACA,WAAA;EACA,qBAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;ADyHR;ACvHQ;EAEE,qBAAA;EACA,wBAAA;ADwHV;ACrHQ;EACE,sCAAA;ADuHV;ACnHM;EACE,kBAAA;EACA,UAAA;EACA,YAAA;ADqHR;AClHU;EACE,eAAA;ADoHZ;AC/GU;EACE,eAAA;ADiHZ;AC5GM;EACE,kBAAA;EACA,YAAA;AD8GR;AC5GQ;EACE,WAAA;AD8GV;;ACtGE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,gBAAA;ADyGJ;;ACpGE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;ADuGJ;ACrGI;EACE,mBAAA;ADuGN;ACpGI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;ADsGN;ACnGI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;EACA,gBAAA;ADqGN;AClGI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;ADoGN;;AC9FE;EACE,gBAAA;ADiGJ;AC/FI;EACE,WAAA;EACA,iBAAA;ADiGN;AC9FI;EACE,YAAA;ADgGN;AC5FE;EACE,iBAAA;EACA,iFACE;AD6FN;AC1FI;EACE,WAAA;AD4FN;ACzFI;EACE,YAAA;AD2FN;;ACrFE;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,2BAAA;ADwFJ;;ACpFA;EACE,eAAA;EACA,oBAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;ADuFF;ACrFE;EACE,iBAAA;ADuFJ;ACpFE;EACE,sBAAA;ADsFJ;ACnFE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;ADqFJ;;AChFE;EACE,WAAA;EACA,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,iFACE;ADkFN;AC/EI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;EACA,qBAAA;EACA,gBAAA;ADiFN;AC9EQ;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,cAAA;EACA,6BAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,uDAAA;EACA,6DAAA;ADgFV;AC1EE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AD4EJ;ACzEM;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AD2ER;ACxEM;EACE,yBAAA;AD0ER;ACxEQ;EACE,yBAAA;AD0EV;ACtEM;EACE,yBAAA;ADwER;ACtEQ;EACE,yBAAA;ADwEV;ACpEM;EACE,yBAAA;ADsER;ACpEQ;EACE,yBAAA;ADsEV;ACjEI;EACE,WAAA;EACA,YAAA;ADmEN;AChEQ;EACE,UAAA;EACA,WAAA;ADkEV;;AC3DA;EACE,2BAAA;AD8DF;AC5DE;EACE,YAAA;AD8DJ;;ACzDE;EACE,QAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;AD4DJ;ACvDM;EACE,yBAAA;ADyDR;ACrDI;EACE,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;ADuDN;ACrDM;EACE,yBAAA;ADuDR;ACnDI;EACE,qBAAA;ADqDN;AClDQ;EACE,qBAAA;ADoDV;AChDM;EACE,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;ADkDR;AC9CM;EACE,iCAAA;EACA,qBAAA;EACA,gBAAA;ADgDR;AC9CQ;EACE,yBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;ADgDV;;ACzCA;EACE,cAAA;AD4CF;;ACxCE;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AD2CJ;ACxCE;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AD0CJ;;ACtCA;EACE,gBAAA;EACA,cAAA;EACA,+BAAA;ADyCF;ACvCE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;ADyCJ;;ACrCA;EACE,qBAAA;ADwCF;;ACpCE;EACE,kBAAA;ADuCJ;;ACnCA;EACE,yBAAA;ADsCF;;ACnCA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,OAAA;ADsCF;;AClCE;EACE,QAAA;ADqCJ;AClCE;EACE,iCAAA;EACA,sBAAA;EACA,mBAAA;ADoCJ;AClCI;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;ADoCN;ACjCI;;EAEE,UAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,yBAAA;ADmCN;AC/BM;EACE,eAAA;EACA,iBAAA;ADiCR;AC5BM;EACE,eAAA;EACA,iBAAA;AD8BR;ACzBE;EACE,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,gCAAA;AD2BJ;ACxBE;;;;;;;;;;;;EAYE,kBAAA;AD0BJ;ACvBE;EACE,SAAA;EACA,OAAA;EACA,sBAAA;ADyBJ;ACtBE;EACE,SAAA;EACA,aAAA;EACA,QAAA;EACA,sBAAA;ADwBJ;ACrBE;;EAEE,kBAAA;ADuBJ;ACrBI;;EACE,gBAAA;EACA,6BAAA;ADwBN;ACrBI;;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;ADwBN;ACnBI;EAME,WAAA;EAMA,oBAAA;ADWN;ACtBM;EACE,+BAAA;EACA,kBAAA;ADwBR;ACpBM;EACE,8BAAA;EACA,kBAAA;ADsBR;AClBM;EACE,gBAAA;EACA,kBAAA;ADoBR;;ACTQ;EACE,UAAA;EACA,YAAA;ADYV;ACNE;EACE,YAAA;EACA,UAAA;ADQJ;ACLE;EACE,YAAA;EACA,UAAA;ADOJ;;ACHA;EACE,cAAA;ADMF;;ACHA;EACE,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,aAAA;EACA,4BAAA;ADMF;;ACFE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;ADKJ;ACHI;EACE,kBAAA;ADKN;ACFI;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;ADIN;;ACCA;EACE,eAAA;ADEF;;ACCA;;EAEE,wBAAA;ADEF;;AGrtBE;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AHwtBJ;AGttBE;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,SAAA;AHwtBJ;;AGptBA;EAGE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;AHqtBF;AGntBE;EACE,WAAA;EACA,YAAA;AHqtBJ;;AGhtBE;EACE,gBAAA;AHmtBJ;;AG/sBA;EACE,iCAAA;EACA,0BAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AHktBF;AGhtBE;EACE,YAAA;AHktBJ;AGhtBE;EACE,YAAA;EACA,yBAAA;EACA,yBChCK;AJkvBT;AGhtBI;EACE,yBClCC;AJovBP;AGhtBI;EACE,yBCvCG;AJyvBT;AGhtBI;EACE,yBCnEG;AJqxBT;AG9sBE;EACE,cC9CK;ED+CL,qBAAA;EACA,6BAAA;EACA,yBAAA;AHgtBJ;AG9sBI;EACE,cCnDC;EDoDD,qBCpDC;AJowBP;AG9sBI;EACE,cCzDG;ED0DH,qBC1DG;AJ0wBT;AG9sBI;EACE,cCtFG;EDuFH,qBCvFG;AJuyBT;AG5sBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AH8sBJ;AG3sBE;EACE,0BAAA;EACA,aAAA;EACA,mBAAA;AH6sBJ;AG3sBI;EACE,kBAAA;AH6sBN;AGzsBE;EACE,YAAA;AH2sBJ;AGxsBE;EACE,eAAA;AH0sBJ;AGvsBE;EACE,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,6BAAA;EACA,uBAAA;EACA,eAAA;AHysBJ;AGvsBI;EACE,aAAA;AHysBN;AGrsBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,0BAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;AHusBJ;AGpsBE;EACE,eAAA;AHssBJ;AGnsBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AHqsBJ;;AGjsBA;EACE,eCvIO;EDwIP,gCAAA;AHosBF;AGlsBE;EACE,eC1IG;AJ80BP;AGjsBE;EACE,eChJK;AJm1BT;AGhsBE;EACE,eC7KK;AJ+2BT;;AG9rBA;EACE,eAAA;AHisBF;;AG3rBM;EACE,aAAA;AH8rBR;AG1rBI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,kEAAA;EACA,kBAAA;AH4rBN;AG1rBM;EACE,aAAA;AH4rBR;AGvrBM;EACE,aAAA;AHyrBR;;AGlrBE;EACE,eC1LK;AJ+2BT;AGnrBE;EACE,eAAA;EACA,wBAAA;AHqrBJ;AGnrBE;EACE,yBAAA;AHqrBJ;;AGjrBA;EACE,eAAA;AHorBF;;AGjrBA;EACE,WAAA;EACA,WAAA;EACA,yBAAA;AHorBF;;AGjrBA;EACE,8BAAA;AHorBF;;AGlrBA;EACE,8BAAA;AHqrBF;;AGlrBA;EACE,aAAA;EACA,8BAAA;AHqrBF;;AGjrBE;EACE,cAAA;AHorBJ;;AGhrBA;EACE,yBAAA;AHmrBF;;AKn7BA;EACE,gBAAA;ALs7BF;;AKn7BA;EACE,kBAAA;EACA,oCAAA;EACA,6BAAA;EACA,eAAA;ALs7BF;;AKn7BA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ALs7BF;;AKn7BA;EACE,oBAAA;ALs7BF;;AKn7BA;EACE,kBAAA;EACA,kBAAA;ALs7BF;AKr7BE;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,cAAA;ALu7BJ;AKr7BE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,mBAAA;EACA,kBAAA;ALu7BJ;AKr7BI;EACE,eAAA;EACA,iBAAA;EACA,uBAAA;ALu7BN;AKr7BI;EACE,gBAAA;ALu7BN;;AKj7BE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,yBD3DI;EC4DJ,aAAA;EACA,WAAA;EACA,gBAAA;ALo7BJ;AAz9BE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AA29BJ;AAx9BE;EACE,+BAAA;EACA,kBAAA;AA09BJ;AAv9BE;EACE,8BAAA;EACA,kBAAA;AAy9BJ;AAt9BE;EACE,gBAAA;EACA,kBAAA;AAw9BJ;AKj8BI;EACE,gBAAA;ALm8BN;AKh8BE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,yBD3EI;EC4EJ,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;ALk8BJ;AKh8BI;EAEE,wBAAA;ALi8BN;AK97BI;EACE,iBAAA;ALg8BN;AK/7BM;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;ALi8BR;AK/7BQ;EACE,MAAA;EACA,WAAA;ALi8BV;AK97BM;EACE,oBAAA;EACA,aAAA;EACA,OAAA;EACA,sBAAA;EACA,mBAAA;ALg8BR;AK/7BQ;EACE,oBAAA;ALi8BV;AK/7BQ;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;ALi8BV;AK/7BU;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;ALi8BZ;AK97BU;EACE,eAAA;EACA,iBAAA;ALg8BZ;AK77BU;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AL+7BZ;AK37BQ;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AL67BV;AK37BU;EACE,cAAA;EACA,gBAAA;AL67BZ;AK17BQ;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AL47BV;AK17BU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AL47BZ;AKz7BQ;EACE,cAAA;EACA,kBAAA;AL27BV;AKx7BM;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;AL07BR;AKx7BQ;EACE,yBAAA;AL07BV;AKv7BQ;EACE,mBAAA;ALy7BV;AKp7BI;EACE,WAAA;EACA,YAAA;ALs7BN;AKp7BI;EACE,aAAA;EACA,aAAA;ALs7BN;AKp7BQ;EADF;IAEI,WAAA;IACA,iBAAA;IACA,kBAAA;ELu7BR;AACF;AKp7BI;EACE,YAAA;EACA,aAAA;ALs7BN;AKp7BM;EACE,YAAA;EACA,aAAA;EACA,iBAAA;ALs7BR;AKn7BU;EACE,iBAAA;ALq7BZ;AKn7BU;EACE,oBAAA;ALq7BZ;AKp7BY;EACE,wBAAA;EACA,WAAA;EACA,YAAA;ALs7Bd;AKp7BY;EACE,WAAA;ALs7Bd;AKh7BQ;EADF;IAEI,WAAA;IACA,YAAA;ELm7BR;AACF;AK/6BU;EADF;IAEI,kBAAA;ELk7BV;AACF;AKh7BQ;EANF;IAOI,WAAA;IACA,YAAA;ELm7BR;AACF;AKh7BI;EACE,YAAA;EACA,aAAA;ALk7BN;AKj7BM;EAHF;IAII,WAAA;ELo7BN;AACF;AKl7BI;EACE,YAAA;EACA,aAAA;ALo7BN;AKn7BM;EAHF;IAII,WAAA;ELs7BN;AACF;AKp7BI;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,gCAAA;ALs7BN;AKp7BM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;ALs7BR;AKp7BQ;EACE,SAAA;ALs7BV;AKl7BI;EACE,YAAA;ALo7BN;AKh7BE;EACE,kBAAA;EACA,mBAAA;ALk7BJ;AKh7BI;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;ALk7BN;AKj7BM;EATF;IAUI,sBAAA;IACA,kBAAA;ELo7BN;AACF;AKl7BQ;EADF;IAEI,cAAA;ELq7BR;AACF;AKl7BI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;ALo7BN;AKj7BI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,gCAAA;ALm7BN;AKh7BI;EACE,kBAAA;ALk7BN;AKh7BM;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;ALk7BR;AK/6BM;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,OAAA;EACA,cAAA;ALi7BR;AK76BI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;AL+6BN;AK56BE;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,gCAAA;AL86BJ;AK56BI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AL86BN;AK76BM;EACE,kBAAA;EACA,mBAAA;AL+6BR;AK56BM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AL86BR;AK36BM;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;AL66BR;AKz6BE;EACE,OAAA;EACA,YAAA;AL26BJ;AKz6BE;EACE,gBAAA;AL26BJ;AKz6BE;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AL26BJ;AKz6BI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;AL26BN;AKx6BI;EACE,cAAA;AL06BN;AKz6BM;EACE,iBAAA;AL26BR;;AKr6BA;EACE,kBAAA;ALw6BF;;AKr6BA;EACE,eAAA;EACA,6BAAA;ALw6BF;AKt6BE;EACE,gBAAA;ALw6BJ;;AKn6BE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;ALs6BJ;AKp6BI;EACE,gBAAA;ALs6BN;;AKh6BE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cDvdI;ECwdJ,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;ALm6BJ;AKl6BI;EACE,eAAA;EACA,iBAAA;ALo6BN;AKl6BI;EACE,yBD1cG;AJ82CT;AKl6BI;EACE,yBDzcK;AJ62CX;AKl6BI;EACE,yBD9cA;AJk3CN;;AK95BE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;ALi6BJ;AK/5BI;EACE,iBAAA;ALi6BN;AK95BE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;ALg6BJ;AK95BI;EACE,iBAAA;ALg6BN;;AK35BA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;AL85BF;;AK35BA;EACE,oBAAA;AL85BF;AK75BE;EACE,cAAA;AL+5BJ;AK75BE;EACE,yBAAA;AL+5BJ;;AK35BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;AL85BF;AK55BI;EADF;IAEI,eAAA;EL+5BJ;AACF;AK75BM;EADF;IAEI,iBAAA;ELg6BN;AACF;AK55BM;EAFF;;IAGI,UAAA;ELg6BN;AACF;AK75BI;EAhBF;IAiBI,sBAAA;ELg6BJ;AACF;AK95BE;EA5BF;IA6BI,uBAAA;ELi6BF;AACF;AK/5BE;EHljBA,eAAA;EACA,iBAAA;EGmjBE,sBAAA;EACA,yBAAA;EACA,cAAA;ALk6BJ;AK/5BE;EH/iBA,eAAA;EACA,iBAAA;EACA,uBAAA;EG+iBE,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;ALm6BJ;AKh6BE;EACE,cAAA;ALk6BJ;AK/5BE;EACE,2BAAA;ALi6BJ;AKh6BI;EHvkBF,eAAA;EACA,iBAAA;EGwkBI,sBAAA;EACA,yBAAA;EACA,cAAA;ALm6BN;;AK95BA;EH3kBE,eAAA;EACA,iBAAA;EG4kBA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;ALk6BF;;AK/5BA;EACE,yBAAA;ALk6BF;AKh6BE;EACE,oBAAA;EACA,yBAAA;ALk6BJ;AKj6BI;EAHF;IAII,YAAA;ELo6BJ;AACF;AKl6BI;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;ALo6BN;AKj6BI;EACE,cAAA;ALm6BN;AKh6BI;EACE,YAAA;ALk6BN;AKj6BM;EACE,aAAA;EACA,YAAA;EACA,yBDnnBA;EConBA,iDAAA;EACA,mDAAA;ALm6BR;AK/5BE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;ALi6BJ;AK/5BI;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;ALi6BN;AKh6BM;EACE,iBAAA;ALk6BR;;AK55BA;EACE,iBAAA;AL+5BF;;AK15BI;EAEE,YAAA;AL45BN;AK15BM;EACE,WAAA;EACA,oEAAA;EACA,oBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;AL45BR;AKz5BI;EACE,YAAA;AL25BN;AKz5BI;EACE,WAAA;AL25BN;AK15BM;EACE,yBAAA;AL45BR;;AKt5BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;ALy5BF;AKx5BE;EACE,aAAA;AL05BJ;AKx5BE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;AL05BJ;AKv5BE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;ALy5BJ;;AKp5BE;EACE,iBAAA;EACA,oBAAA;ALu5BJ;AKr5BI;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;ALu5BN;;AKl5BA;EACE,gBAAA;ALq5BF;;AKl5BA;EACE,kBAAA;ALq5BF;AKp5BE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,aAAA;ALs5BJ;;AKj5BE;EACE,sBAAA;EACA,YAAA;EACA,mBAAA;ALo5BJ;;AKh5BA;EACE,aAAA;ALm5BF;;AK/4BE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;ALk5BJ;AKj5BI;EAVF;IAWI,MAAA;ELo5BJ;AACF;AKn5BI;EACE,kBAAA;EACA,QAAA;ALq5BN;AKl5BM;EADF;IAEI,WAAA;ELq5BN;AACF;AKn5BI;EACE,eAAA;EACA,iBAAA;EACA,SAAA;EACA,QAAA;ALq5BN;AKn5BM;EACE,WAAA;ALq5BR;AKn5BM;EACE,gBAAA;ALq5BR;AKj5BI;EACE,iBAAA;ALm5BN;AKl5BM;EAFF;IAGI,eAAA;IACA,gBAAA;ELq5BN;AACF;;AKh5BA;EACE,YAAA;EACA,oBAAA;ALm5BF;;AKh5BA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;ALm5BF;;AKh5BA;EACE,YAAA;ALm5BF;AA/qDE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAirDJ;AA9qDE;EACE,+BAAA;EACA,kBAAA;AAgrDJ;AA7qDE;EACE,8BAAA;EACA,kBAAA;AA+qDJ;AA5qDE;EACE,gBAAA;EACA,kBAAA;AA8qDJ;;AK95BA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;ALi6BF;;AK/5BA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;ALk6BF;;AK/5BE;EACE,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;ALk6BJ;AKh6BI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ALk6BN;AK75BQ;EACE,2BAAA;AL+5BV;AK55BM;EACE,YAAA;EACA,oBAAA;EACA,6BAAA;EACA,uBAAA;EACA,2BAAA;AL85BR;AK55BQ;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,mCAAA;AL85BV;AK35BM;EACE,sBAAA;AL65BR;AKx5BM;EACE,gBAAA;AL05BR;AKr5BE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uGAAA;ALu5BJ;AKt5BI;EACE,WAAA;EACA,8BAAA;EACA,8BAAA;ALw5BN;AKt5BM;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ALw5BR;AKt5BM;EACE,WAAA;ALw5BR;AKp5BM;EACE,4CAAA;EACA,eAAA;EACA,4BAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,2BAAA;EACA,+BAAA;ALs5BR;AKp5BQ;EACE,wCAAA;ALs5BV;AKn5BQ;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;ALq5BV;AKl5BM;EACE,gBAAA;EACA,yBAAA;EACA,wCAAA;ALo5BR;AKj5BI;EACE,qBAAA;EACA,+CAAA;ALm5BN;;AK74BE;EACE,mBAAA;ALg5BJ;AK94BE;EACE,cAAA;ALg5BJ;AK94BE;EACE,OAAA;EACA,YAAA;ALg5BJ;AK94BE;EACE,kBAAA;EACA,cAAA;ALg5BJ;;AMr1DA;EACE,cAAA;ANw1DF;AMv1DE;;;EAGE,0BAAA;EACA,6BAAA;EACA,2CAAA;ANy1DJ;AMv1DE;EACE,+BAAA;EACA,iBAAA;ANy1DJ;AMv1DM;EACE,YAAA;EACA,WAAA;ANy1DR;AMr1DE;EACE,+BAAA;EACA,iBAAA;ANu1DJ;AMr1DM;EACE,WAAA;EACA,YAAA;ANu1DR;AMn1DE;EACE,kBAAA;EACA,+BAAA;EACA,iBAAA;ANq1DJ;AMn1DM;EACE,WAAA;EACA,YAAA;ANq1DR;AMj1DE;EACE,+BAAA;EACA,iBAAA;ANm1DJ;AMj1DM;EACE,WAAA;EACA,YAAA;ANm1DR;AM/0DE;EACE,mBAAA;EACA,kBAAA;ANi1DJ;AM/0DE;EACE,YAAA;EACA,UAAA;ANi1DJ;AM/0DE;EACE,mBAAA;ANi1DJ;AM/0DE;EACE,kBAAA;EACA,kBAAA;ANi1DJ;AM/0DE;;;EAGE,kBAAA;EACA,gBAAA;ANi1DJ;AM/0DE;EACE,kBAAA;ANi1DJ;AM70DE;EACE,8BAAA;EACA,8BAAA;AN+0DJ;AM50DE;EACE,kBAAA;EACA,kBAAA;AN80DJ;AM50DE;EACE,kBAAA;EACA,kBAAA;AN80DJ;AM50DE;EACE,uCAAA;AN80DJ;AM50DE;EACE,kBAAA;AN80DJ;AM50DE;EACE,mBAAA;AN80DJ;AM50DE;EACE,kBAAA;EACA,kBAAA;AN80DJ;AM50DE;;EAEE,YAAA;EACA,WAAA;AN80DJ;AM50DE;EACE,cAAA;EACA,kBAAA;AN80DJ;AM50DE;EACE,mBAAA;AN80DJ;AM50DE;EACE,kBAAA;EACA,mBAAA;AN80DJ;AM50DE;EACE,kBAAA;AN80DJ;AM50DE;;EAEE,kBAAA;AN80DJ;AM50DE;EACE,uBAAA;EACA,OAAA;AN80DJ;AM50DE;EACE,kBAAA;AN80DJ;AM50DE;EACE,kBAAA;AN80DJ;AM50DE;EACE,mBAAA;AN80DJ;AM50DE;EACE,YAAA;EACA,SAAA;AN80DJ;AM50DE;EACE,sBAAA;AN80DJ;AM50DE;EACE,yBAAA;AN80DJ;AM50DE;EACE,yBAAA;EACA,gBAAA;AN80DJ;AMx0DE;EACE,eAAA;EACA,iBAAA;AN00DJ;AMx0DE;EACE,eAAA;EACA,iBAAA;AN00DJ;AMx0DE;EACE,eAAA;EACA,iBAAA;AN00DJ;AMv0DE;EACE,SAAA;EACA,UAAA;ANy0DJ;AMv0DE;EACE,kBAAA;ANy0DJ;AMv0DE;EACE,eAAA;EACA,iBAAA;ANy0DJ;AMv0DE;EACE,uCAAA;ANy0DJ;AMv0DE;EACE,kBAAA;ANy0DJ;AMv0DE;EACE,eAAA;ANy0DJ;AMv0DE;EACE,YAAA;EACA,OAAA;ANy0DJ;;AOxgEA;;;;;;;;;;EAUE,gBAAA;AP2gEF;;AOxgEA;EACE,iCAAA;EACA,sBAAA;AP2gEF;;AOxgEA;EACE,eAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;AP2gEF;AAzgEE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AA2gEJ;AAxgEE;EACE,+BAAA;EACA,kBAAA;AA0gEJ;AAvgEE;EACE,8BAAA;EACA,kBAAA;AAygEJ;AAtgEE;EACE,gBAAA;EACA,kBAAA;AAwgEJ;AOxhEE;EACE,yBAAA;EACA,6BAAA;AP0hEJ;AOxhEI;EACE,6BAAA;AP0hEN;AOthEE;EACE,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;APwhEJ;AOrhEE;EACE,yBAAA;EACA,aAAA;APuhEJ;AOrhEI;EAJF;IAKI,kBAAA;EPwhEJ;AACF;AOthEI;EACE,+BAAA;APwhEN;AOnhEI;EACE,aHzCQ;AJ8jEd;AOnhEM;EACE,aH5CM;AJikEd;AOhhEE;EACE,cAAA;APkhEJ;;AO9gEA;EACE,yDAAA;APihEF;AO/gEE;EACE,oDAAA;APihEJ;AO9gEE;EACE,0CAAA;EACA,yCAAA;APghEJ;AO7gEE;EACE,mDAAA;AP+gEJ;AO5gEE;EACE,2DAAA;AP8gEJ;AO3gEE;EACE,0CAAA;EACA,yCAAA;AP6gEJ;;AOxgEA;EACE,yBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AP2gEF;;AOxgEA;EACE,yBAAA;AP2gEF;;AOxgEA;EACE,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,UAAA;AP2gEF;;AOxgEA;EACE,UAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AP2gEF;;AOxgEA;EACE,yBAAA;AP2gEF;;AOxgEA;EACE,gBAAA;AP2gEF;;AOxgEA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;AP2gEF;AOzgEE;EACE,eAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AP2gEJ;;AOvgEA;EACE,aAAA;AP0gEF;;AOvgEA;EACE,iBAAA;AP0gEF;;AQxqEA;EACE,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,mCAAA;EACA,2CAAA;EACA,2CAAA;EACA,2CAAA;EACA,qCAAA;EACA,8BAAA;EACA,8BAAA;EACA,gCAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,qCAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,qBAAA;EACA,uBAAA;EACA,wBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EAEA,oCAAA;EACA,6CAAA;EACA,4CAAA;EACA,0CAAA;EACA,sCAAA;EACA,+BAAA;EACA,+BAAA;EACA,iCAAA;EACA,gCAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,8BAAA;EACA,8BAAA;EACA,kCAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,yBAAA;EAEA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,2BAAA;EACA,2BAAA;ARwqEF;;AS3vEA;EACE,0DAAA;EACA,iEAAA;EACA,qDAAA;EACA,gEAAA;EACA,mDAAA;EACA,qEAAA;EACA,0DAAA;EACA,4DAAA;EACA,mDAAA;EACA,4DAAA;EACA,0DAAA;EACA,+CAAA;EACA,+DAAA;EACA,8DAAA;EACA,yDAAA;EACA,2DAAA;EACA,gDAAA;EACA,wDAAA;EACA,gEAAA;EACA,4DAAA;EACA,+CAAA;EACA,+DAAA;EACA,+DAAA;EACA,kEAAA;EACA,yDAAA;EACA,qEAAA;EACA,wCAAA;EACA,uDAAA;EACA,6DAAA;EACA,8CAAA;EACA,qEAAA;EACA,uEAAA;EACA,oEAAA;EACA,gEAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,qDAAA;EACA,sDAAA;EACA,mEAAA;EACA,oEAAA;EACA,+CAAA;EACA,sDAAA;EACA,6DAAA;EACA,0DAAA;EACA,iEAAA;EACA,wEAAA;EACA,8DAAA;EACA,mDAAA;EACA,sDAAA;EACA,iDAAA;EACA,uDAAA;EACA,wDAAA;EACA,6DAAA;EACA,qDAAA;EACA,6CAAA;EACA,gDAAA;EACA,+CAAA;EACA,8DAAA;EACA,oEAAA;EACA,mEAAA;EACA,qEAAA;EACA,qEAAA;EACA,kEAAA;EACA,6DAAA;EACA,qEAAA;EACA,kEAAA;EACA,iEAAA;EACA,gEAAA;EACA,wEAAA;EACA,oEAAA;EACA,oDAAA;EACA,6DAAA;EACA,mEAAA;EACA,0EAAA;EACA,0EAAA;EACA,sEAAA;EACA,6EAAA;EACA,2EAAA;EACA,wDAAA;EACA,iEAAA;EACA,iEAAA;EACA,6DAAA;EACA,4DAAA;EACA,yEAAA;EACA,gEAAA;EACA,yDAAA;EACA,+DAAA;EACA,wEAAA;EACA,oEAAA;EACA,sDAAA;EACA,iDAAA;EACA,sEAAA;EACA,mDAAA;EACA,iDAAA;EACA,wEAAA;EACA,sEAAA;EACA,gEAAA;EACA,kEAAA;EACA,wDAAA;EACA,uEAAA;EACA,sEAAA;EACA,gEAAA;EACA,kEAAA;EACA,uDAAA;EACA,0EAAA;EACA,0EAAA;EACA,oEAAA;EACA,sEAAA;EACA,0DAAA;EACA,qEAAA;EACA,gFAAA;EACA,2EAAA;EACA,mFAAA;EACA,4EAAA;EACA,8EAAA;EACA,kEAAA;EACA,mFAAA;EACA,iGAAA;EACA,gEAAA;EACA,wEAAA;EACA,gFAAA;EACA,8FAAA;EACA,6DAAA;EACA,qEAAA;EACA,iFAAA;EACA,iFAAA;EACA,+FAAA;EACA,8DAAA;EACA,sEAAA;EACA,wEAAA;EACA,mDAAA;EACA,wDAAA;EACA,8DAAA;EACA,wDAAA;EACA,sDAAA;EACA,gDAAA;EACA,iDAAA;EACA,8DAAA;EACA,wDAAA;EACA,0DAAA;EACA,mEAAA;EACA,2FAAA;EACA,yDAAA;EACA,gFAAA;EACA,8EAAA;EACA,mEAAA;EACA,6EAAA;EACA,uDAAA;EACA,yDAAA;EACA,gFAAA;EACA,oEAAA;EACA,mFAAA;EACA,oEAAA;EACA,0EAAA;EACA,kEAAA;EACA,4DAAA;EACA,mEAAA;EACA,6EAAA;EACA,mEAAA;EACA,wDAAA;EACA,gEAAA;EACA,0DAAA;EACA,2DAAA;EACA,iDAAA;EACA,0DAAA;EACA,qDAAA;EACA,2DAAA;EACA,yDAAA;EACA,gDAAA;EACA,iDAAA;EACA,iDAAA;EACA,6CAAA;EACA,qEAAA;EACA,qEAAA;EACA,+DAAA;EACA,2DAAA;EACA,gEAAA;EACA,8DAAA;EACA,oEAAA;EACA,4BAAA;EAEA;2CAAA;EAEA,iGAAA;EACA,mGAAA;EACA,wGAAA;EACA,mGAAA;EACA,+CAAA;AT6vEF;;AU17EA;EACE,2DAAA;EACA,0DAAA;EACA,qDAAA;EACA,8DAAA;EACA,0DAAA;EACA,8DAAA;EACA,2DAAA;EACA,qDAAA;EACA,mDAAA;EACA,0DAAA;EACA,yDAAA;EACA,mDAAA;EACA,8DAAA;EACA,4DAAA;EACA,0DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yDAAA;EACA,+DAAA;EACA,0DAAA;EACA,mDAAA;EACA,8DAAA;EACA,6DAAA;EACA,2DAAA;EACA,wDAAA;EACA,qEAAA;EACA,wCAAA;EACA,uDAAA;EACA,6DAAA;EACA,8CAAA;EACA,mEAAA;EACA,qEAAA;EACA,mEAAA;EACA,iEAAA;EACA,0DAAA;EACA,2DAAA;EACA,6DAAA;EACA,yDAAA;EACA,kDAAA;EACA,kEAAA;EACA,mEAAA;EACA,+CAAA;EACA,oDAAA;EACA,sDAAA;EACA,yDAAA;EACA,0DAAA;EACA,uEAAA;EACA,6DAAA;EACA,mDAAA;EACA,oDAAA;EACA,wDAAA;EACA,gDAAA;EACA,wDAAA;EACA,6DAAA;EACA,qDAAA;EACA,6CAAA;EACA,8CAAA;EACA,mDAAA;EACA,8DAAA;EACA,6DAAA;EACA,kEAAA;EACA,qEAAA;EACA,8DAAA;EACA,kEAAA;EACA,2DAAA;EACA,oEAAA;EACA,2DAAA;EACA,wEAAA;EACA,gEAAA;EACA,uEAAA;EACA,mEAAA;EACA,kDAAA;EACA,2DAAA;EACA,mEAAA;EACA,mEAAA;EACA,yEAAA;EACA,6EAAA;EACA,4EAAA;EACA,0EAAA;EACA,sDAAA;EACA,qEAAA;EACA,iEAAA;EACA,oEAAA;EACA,4DAAA;EACA,yEAAA;EACA,+DAAA;EACA,wDAAA;EACA,iEAAA;EACA,sEAAA;EACA,mEAAA;EACA,qDAAA;EACA,0CAAA;EACA,qEAAA;EACA,mDAAA;EACA,iDAAA;EACA,wEAAA;EACA,sEAAA;EACA,gEAAA;EACA,iEAAA;EACA,+DAAA;EACA,uEAAA;EACA,sEAAA;EACA,gEAAA;EACA,iEAAA;EACA,8DAAA;EACA,0EAAA;EACA,0EAAA;EACA,oEAAA;EACA,qEAAA;EACA,iEAAA;EACA,qEAAA;EACA,+EAAA;EACA,2EAAA;EACA,kFAAA;EACA,qEAAA;EACA,6EAAA;EACA,yEAAA;EACA,2EAAA;EACA,+FAAA;EACA,+DAAA;EACA,wEAAA;EACA,wEAAA;EACA,4FAAA;EACA,4DAAA;EACA,qEAAA;EACA,gFAAA;EACA,yEAAA;EACA,6FAAA;EACA,6DAAA;EACA,sEAAA;EACA,sEAAA;EACA,mDAAA;EACA,wDAAA;EACA,8DAAA;EACA,wDAAA;EACA,sDAAA;EACA,gDAAA;EACA,iDAAA;EACA,8DAAA;EACA,wDAAA;EACA,oDAAA;EACA,0EAAA;EACA,yFAAA;EACA,wDAAA;EACA,+EAAA;EACA,uEAAA;EACA,4DAAA;EACA,sEAAA;EACA,sDAAA;EACA,yDAAA;EACA,+EAAA;EACA,kEAAA;EACA,kFAAA;EACA,oEAAA;EACA,mEAAA;EACA,kEAAA;EACA,mEAAA;EACA,mEAAA;EACA,sEAAA;EACA,mEAAA;EACA,iDAAA;EACA,yDAAA;EACA,mDAAA;EACA,oDAAA;EACA,gDAAA;EACA,mDAAA;EACA,mDAAA;EACA,oDAAA;EACA,kDAAA;EACA,kDAAA;EACA,iDAAA;EACA,iDAAA;EACA,sDAAA;EACA,6EAAA;EACA,oEAAA;EACA,6DAAA;EACA,2DAAA;EACA,gEAAA;EACA,uDAAA;EACA,6DAAA;EACA,4BAAA;EAEA,2GAAA;EACA,mGAAA;EACA,iGAAA;EACA,wGAAA;EACA,2GAAA;EACA,kDAAA;EACA,4CAAA;AV47EF","sourcesContent":["\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.mb-25 {\n  margin-bottom: 25px !important;\n}\n\n.mt-25 {\n  margin-top: 25px !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-4 {\n  padding-bottom: 15px !important;\n}\n\n.pr-15 {\n  padding-right: 15px !important;\n}\n\n.pr-24 {\n  padding-right: 24px !important;\n}\n\n.pr-35 {\n  padding-right: 35px !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.fw-bold {\n  font-weight: bold !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.cursor-pointer {\n  cursor: pointer !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-none {\n  display: none !important;\n}","%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n@import './temporaryBootstrap.scss';\n@import './_input-fields.scss';\n@import './_base.scss';\n@import './_components.scss';\n@import './variables.scss';\n@import './rtl.scss';\n@import './main.scss';\n@import '../constants/styles/themes.scss';\n","@import './variables.scss';\n@import './mixins.scss';\n\ninput,\ntextarea {\n  &::placeholder {\n    font-size: 12px;\n    line-height: 18px;\n    color: #7a7a9d;\n  }\n}\n\ninput {\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  &[type='number'] {\n    -moz-appearance: textfield;\n  }\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0 1000px rgba(250, 250, 251, 1) inset;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\ntextarea {\n  @include scrollBar;\n}\n\n// FORM_FIELDS\n.form-control {\n  &-item {\n    width: 100%;\n    position: relative;\n\n    &>label {\n      @include small-text;\n      font-weight: 500;\n      letter-spacing: 0.05em;\n      text-transform: uppercase;\n      color: #000000;\n      margin-bottom: 8px;\n      padding-right: 17px;\n    }\n\n    .error-input {\n      fieldset {\n        border-color: #f24f52 !important;\n      }\n    }\n\n    &.checkbox-input {\n      margin-top: 6px;\n      margin-left: 0;\n      margin-right: 0;\n      display: flex;\n      flex-direction: row;\n\n      .checkbox-label {\n        @include medium-text;\n        font-weight: 400;\n        line-height: 18px;\n        color: #333333;\n        letter-spacing: 0;\n        text-transform: none;\n        margin-bottom: 0;\n        padding-right: 0;\n      }\n    }\n\n    &.radio-buttons {\n      margin-top: 20px;\n\n      .radio-buttons-group {\n        background: #fafafb;\n        border-radius: 5px;\n\n        &__label {\n          @include medium-text;\n          margin: 0;\n          padding: 11px;\n          border: 1px solid #ffffff;\n        }\n      }\n    }\n\n    &.textarea-input {\n      fieldset {\n        border: 1px solid #d0d6e5;\n        border-radius: 5px;\n      }\n\n      .end-adornment {\n        @include small-text;\n        color: #75899d;\n      }\n    }\n\n    &.select-input {\n      .svg-arrow {\n        stroke: #6b7682;\n        position: absolute;\n        right: 15px;\n      }\n    }\n\n    &.input-field {\n      &.no-input-border {\n        fieldset {\n          border: none !important;\n        }\n      }\n\n      fieldset {\n        border: 1px solid #d0d6e5;\n        border-radius: 5px;\n      }\n\n      input {\n        padding: 0;\n      }\n\n      .end-adornment {\n        @include medium-text;\n        color: #75899d;\n      }\n    }\n\n    &.datepicker {\n      width: 100%;\n\n      &.with-start-icon {\n        input {\n          padding-left: 47px;\n        }\n      }\n\n      &.datepicker-border-yellow {\n        input {\n          border-color: #fdc526 !important;\n        }\n      }\n\n      input {\n        @include medium-text;\n        color: #000000;\n        width: 100%;\n        padding: 7px 12px 6px;\n        background: rgba(255, 255, 255, 0.5);\n        border: 1px solid #d0d6e5;\n        border-radius: 5px;\n\n        &:focus,\n        &:active {\n          border-color: #3c97aa;\n          outline: none !important;\n        }\n\n        &:disabled {\n          border-color: rgba(208, 214, 229, 0.5);\n        }\n      }\n\n      .datepicker__clock-icon {\n        position: absolute;\n        left: 15px;\n        bottom: 10px;\n\n        &.clock-activated {\n          path {\n            stroke: #42ad7e;\n          }\n        }\n\n        &.clock-deactivated {\n          path {\n            stroke: #f27244;\n          }\n        }\n      }\n\n      .datepicker__calendar-icon {\n        position: absolute;\n        bottom: 10px;\n\n        &.calendar-end {\n          right: 13px;\n        }\n      }\n    }\n  }\n}\n\n.required-field {\n  &::after {\n    content: '*';\n    font-size: 10px;\n    line-height: 12px;\n    color: var(--inputs-error-stroke);\n    margin-left: 4px;\n  }\n}\n\n.attachments {\n  &-field {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border: 1px dashed #3c97aa;\n\n    &-icon {\n      margin-bottom: 10px;\n    }\n\n    &-support {\n      font-size: 12px;\n      line-height: 12px;\n      color: #75899D;\n      margin-top: 12px;\n    }\n\n    &-link {\n      font-size: 14px;\n      line-height: 12px;\n      color: #3c97aa;\n      text-decoration: underline;\n      padding-top: 5px;\n    }\n\n    &-desc {\n      font-size: 14px;\n      line-height: 12px;\n      color: #75899D;\n    }\n  }\n}\n\n.select-input-field {\n  &.secondary {\n    min-width: 120px;\n\n    svg {\n      width: 15px;\n      margin-top: -10px;\n    }\n\n    fieldset {\n      border: none;\n    }\n  }\n\n  &.third {\n    padding: 9px 12px;\n    box-shadow:\n      0 3px 8px -1px rgba(50, 50, 71, 0.05),\n      0 0 1px rgba(12, 26, 75, 0.24);\n\n    svg {\n      width: 15px;\n    }\n\n    fieldset {\n      border: none;\n    }\n  }\n}\n\n.switch-field {\n  .switch-label {\n    font-size: 10px;\n    line-height: 12px;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: #75899d;\n    white-space: nowrap;\n    margin-bottom: 0 !important;\n  }\n}\n\n.selectable-item {\n  font-size: 12px;\n  text-transform: none;\n  color: #4a4a4a;\n  padding: 11px 14px 12px;\n  border: 1px solid #ededed;\n  border-radius: 5px;\n  cursor: pointer;\n\n  &:not(:first-child) {\n    margin-left: 15px;\n  }\n\n  &:hover {\n    background-color: #fff;\n  }\n\n  &.is-active {\n    font-weight: 500;\n    color: #4a4a4a;\n    border-color: #fdc526;\n  }\n}\n\n.checkbox-field {\n  &.checkable-tree-all {\n    width: 100%;\n    margin: 0;\n    padding: 3px 12px 3px 1px;\n    background-color: #fafafa;\n    box-shadow:\n      0 0 1px rgba(12, 26, 75, 0.24),\n      0 3px 8px -1px rgba(50, 50, 71, 0.05);\n\n    .checkbox-item {\n      width: 16px;\n      height: 16px;\n      position: relative;\n      background-color: #fff !important;\n      border-color: #d0d6e5;\n      border-radius: 0;\n\n      &.item-checked {\n        &::after {\n          content: '';\n          width: 6px;\n          height: 9px;\n          position: absolute;\n          top: 50%;\n          inset-inline-start: 21.5%;\n          display: table;\n          background-color: transparent;\n          border: 2px solid #3c97aa;\n          border-top: 0;\n          border-left: 0;\n          border-radius: 1px;\n          opacity: 1;\n          transform: rotate(45deg) scale(1) translate(-50%, -50%);\n          transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;\n        }\n      }\n    }\n  }\n\n  .checkbox-item {\n    width: 12px;\n    height: 12px;\n    position: relative;\n    border: 1px solid #3c97aa;\n    border-radius: 2px;\n\n    &.item-checked {\n      &::after {\n        content: '';\n        width: 6px;\n        height: 6px;\n        background-color: #3c97aa;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n      }\n\n      &.standard {\n        border: 1px solid #75899d;\n\n        &::after {\n          background-color: #f8c71c;\n        }\n      }\n\n      &.high {\n        border: 1px solid #75899d;\n\n        &::after {\n          background-color: #f89b11;\n        }\n      }\n\n      &.critical {\n        border: 1px solid #75899d;\n\n        &::after {\n          background-color: #f24f52;\n        }\n      }\n    }\n\n    &.bigger-checkbox {\n      width: 16px;\n      height: 16px;\n\n      &.item-checked {\n        &::after {\n          width: 8px;\n          height: 8px;\n        }\n      }\n    }\n  }\n}\n\n.toggle-password__btn {\n  padding: 0px 8px !important;\n\n  svg {\n    height: 18px;\n  }\n}\n\n.checkable-tree {\n  .ant-tree-switcher {\n    order: 4;\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n  }\n\n  &.ant-tree {\n    .ant-tree-checkbox-indeterminate {\n      .ant-tree-checkbox-inner:after {\n        background-color: #3c97aa;\n      }\n    }\n\n    .ant-tree-treenode {\n      align-items: center;\n      width: 100%;\n      padding: 8px 12px;\n      position: relative;\n\n      &.ant-tree-treenode-checkbox-checked {\n        background-color: #fafafa;\n      }\n    }\n\n    .ant-tree-checkbox {\n      margin-block-start: 0;\n\n      &:hover {\n        .ant-tree-checkbox-inner {\n          border-color: #3c97aa;\n        }\n      }\n\n      &+span {\n        font-family: 'Roboto', sans-serif;\n        font-size: 12px;\n        line-height: 16px;\n        color: #425466;\n        min-height: 16px;\n\n      }\n\n      .ant-tree-checkbox-inner {\n        background-color: #fff !important;\n        border-color: #d0d6e5;\n        border-radius: 0;\n\n        &:after {\n          border: 2px solid #3c97aa;\n          border-top: 0;\n          border-left: 0;\n          border-radius: 1px;\n        }\n      }\n    }\n  }\n}\n\n.ant-tree-treenode-disabled .ant-tree-title {\n  color: #75899d;\n}\n\n.checked-list {\n  &__label {\n    font-size: 8px;\n    font-weight: 500;\n    line-height: 12px;\n    letter-spacing: 0.13em;\n    text-transform: uppercase;\n    color: #a8acb7;\n  }\n\n  &-text {\n    font-size: 10px;\n    line-height: 12px;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: #75899d;\n    max-width: 300px;\n    width: 100%;\n    margin-right: 24px;\n  }\n}\n\n.slider-range {\n  max-width: 100px;\n  margin: 0 20px;\n  padding: 15px 0 16px !important;\n\n  &-block {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n  }\n}\n\n.react-datepicker-popper {\n  z-index: 3 !important;\n}\n\n.autocomplete-input {\n  fieldset {\n    border-radius: 5px;\n  }\n}\n\n.label-gray {\n  color: #808080 !important;\n}\n\n.text-field-error {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  color: #f24f52;\n  position: absolute;\n  top: calc(100% + 3px);\n  left: 0;\n}\n\n.react-datepicker {\n  &__navigation {\n    top: 9px;\n  }\n\n  &__header {\n    font-family: 'Roboto', sans-serif;\n    background-color: #fff;\n    border-bottom: none;\n\n    &__dropdown {\n      display: flex;\n      justify-content: space-around;\n      align-items: center;\n      margin-top: 7px;\n    }\n\n    .react-datepicker__month-read-view--down-arrow,\n    .react-datepicker__year-read-view--down-arrow {\n      width: 7px;\n      height: 7px;\n      right: -12px;\n      top: 3px;\n      border-width: 2px 2px 0 0;\n    }\n\n    .react-datepicker__month-read-view {\n      &--selected-month {\n        font-size: 12px;\n        line-height: 12px;\n      }\n    }\n\n    .react-datepicker__year-read-view {\n      &--selected-year {\n        font-size: 12px;\n        line-height: 12px;\n      }\n    }\n  }\n\n  &__day-names {\n    font-weight: 500;\n    margin-top: 7px;\n    border-top: 1px solid #ededed;\n    border-bottom: 1px solid #ededed;\n  }\n\n  .react-datepicker__day--selected,\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__day--in-range,\n  .react-datepicker__month-text--selected,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__month-text--in-range,\n  .react-datepicker__quarter-text--selected,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-range,\n  .react-datepicker__year-text--selected,\n  .react-datepicker__year-text--in-selecting-range,\n  .react-datepicker__year-text--in-range {\n    border-radius: 50%;\n  }\n\n  .react-datepicker__month-dropdown {\n    top: 40px;\n    left: 0;\n    background-color: #fff;\n  }\n\n  .react-datepicker__year-dropdown {\n    top: 40px;\n    left: initial;\n    right: 0;\n    background-color: #fff;\n  }\n\n  .react-datepicker__month-option,\n  .react-datepicker__year-option {\n    position: relative;\n\n    &:hover {\n      font-weight: 500;\n      background-color: transparent;\n    }\n\n    &--selected {\n      width: 7px;\n      height: 7px;\n      color: transparent;\n      top: 50%;\n      transform: translateY(-50%);\n      background-color: #3c97aa;\n      border-radius: 50%;\n    }\n  }\n\n  &__time {\n    &-list {\n      &::-webkit-scrollbar-track {\n        background: rgba(0, 0, 0, 0.05);\n        border-radius: 3px;\n      }\n\n      /* Handle */\n      &::-webkit-scrollbar-thumb {\n        background: rgba(0, 0, 0, 0.2);\n        border-radius: 3px;\n      }\n\n      /* Handle on hover */\n      &::-webkit-scrollbar-thumb:hover {\n        background: #888;\n        border-radius: 3px;\n      }\n    }\n  }\n}\n\n\n.body-rtl {\n  .main-location-panel {\n    .form-control-item {\n      &.select-input {\n        .svg-arrow {\n          left: 15px;\n          right: unset;\n        }\n      }\n    }\n  }\n\n  .datepicker-range .daterange-field__calendar-icon {\n    right: unset;\n    left: 15px;\n  }\n\n  .form-control-item.select-input .svg-arrow {\n    right: unset;\n    left: 15px;\n  }\n}\n\n.select-rtl {\n  direction: rtl;\n}\n\n.limitation-line-2 {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  /* number of lines to show */\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.users-facility {\n  &-switch {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n\n    label {\n      margin-bottom: 5px;\n    }\n\n    &-subtext {\n      font-size: 8px;\n      font-weight: 400;\n      color: #ABACB7;\n      max-width: 300px;\n      width: 100%;\n    }\n  }\n}\n\n.users-toggle {\n  margin-top: 5px;\n}\n\n.chip-checked-hide,\n.menuItem-hide {\n  display: none !important;\n}","// TEXT-MIXINS\n@mixin small-text {\n  font-size: 10px;\n  line-height: 12px;\n}\n\n@mixin medium-text {\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin big-text {\n  font-size: 18px;\n  line-height: 21px;\n  letter-spacing: 0.055em;\n}\n","@import './variables';\n\n.page {\n  &-title {\n    font-family: 'Roboto', sans-serif;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 21px;\n    color: #000000;\n  }\n  &-details {\n    font-size: 10px;\n    line-height: 12px;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: #75899d;\n    margin: 0;\n  }\n}\n\n.bg-wrapper {\n  //   width: 100vw;\n  //   height: 100vh;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.fw {\n  &-medium {\n    font-weight: 500;\n  }\n}\n\n.btn {\n  font-family: 'Roboto', sans-serif;\n  font-size: 14px !important;\n  font-weight: 500;\n  line-height: 12px;\n  text-transform: uppercase;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 6px 12px;\n  cursor: pointer;\n  width: auto;\n  height: 44px;\n  border-radius: 0 !important;\n\n  &-width {\n    width: 175px;\n  }\n  &.btn-contained {\n    border: none;\n    color: $white !important;\n    background-color: $blue-0;\n\n    &:hover {\n      background-color: $blue;\n    }\n    &:active {\n      background-color: $gray-0;\n    }\n    &:disabled {\n      background-color: $blue-1;\n    }\n  }\n\n  &.btn-outlined {\n    color: $blue-0;\n    text-decoration: none;\n    background-color: transparent;\n    border: 2px solid $blue-0;\n\n    &:hover {\n      color: $blue;\n      border-color: $blue;\n    }\n    &:active {\n      color: $gray-0;\n      border-color: $gray-0;\n    }\n    &:disabled {\n      color: $blue-1;\n      border-color: $blue-1;\n    }\n  }\n\n  &.btn-rounded {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 12px;\n    text-transform: none;\n    border-radius: 4px;\n  }\n\n  &.btn-with-icon {\n    padding: 5px 15px 6px 12px;\n    display: flex;\n    align-items: center;\n\n    svg {\n      margin-right: 10px;\n    }\n  }\n\n  &.btn-medium {\n    height: 35px;\n  }\n\n  &-simple {\n    cursor: pointer;\n  }\n\n  &-extra {\n    font-family: 'Roboto', sans-serif;\n    font-size: 12px;\n    line-height: 12px;\n    color: #3c97aa !important;\n    text-decoration: none;\n    background-color: transparent;\n    border: none !important;\n    cursor: pointer;\n\n    & svg {\n      fill: #3c97aa;\n    }\n  }\n\n  &.btn-alert {\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 12px;\n    text-decoration-line: underline;\n    text-transform: capitalize;\n    color: #ffffff;\n    height: 12px;\n    margin-left: 11px;\n    padding: 0;\n  }\n\n  &-icon {\n    cursor: pointer;\n  }\n\n  &.btn-to-top {\n    width: 44px;\n    height: 44px;\n    position: fixed;\n    right: 25px;\n    bottom: 25px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n.icon-svg {\n  stroke: $blue-0;\n  transition: all 0.3s ease-in-out;\n\n  &:hover {\n    stroke: $blue;\n  }\n\n  &:active {\n    stroke: $gray-0;\n  }\n\n  &:disabled {\n    stroke: $blue-1;\n  }\n}\n\n.icon-arrow {\n  stroke: #6f7983;\n}\n\n.search {\n  input[type='search'] {\n    &:hover {\n      & ~ svg {\n        fill: #6b7682;\n      }\n    }\n\n    &:focus {\n      font-size: 12px;\n      line-height: 12px;\n      color: #242424;\n      background: #fafafb;\n      box-shadow: 0 0 1px #6b7682, 0 2px 5px -1px rgba(50, 50, 71, 0.07);\n      border-radius: 5px;\n\n      & ~ svg {\n        fill: #6b7682;\n      }\n    }\n\n    &:disabled {\n      & ~ svg {\n        fill: #6b7682;\n      }\n    }\n  }\n}\n\n.arrow {\n  &-blue {\n    stroke: $blue-0;\n  }\n  &-back {\n    stroke: #c7cddd;\n    transform: rotate(90deg);\n  }\n  &-top {\n    transform: rotate(180deg);\n  }\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.separator {\n  width: 100%;\n  height: 1px;\n  background-color: #ededed;\n}\n\n.pr-15 {\n  padding-right: 15px !important;\n}\n.pr-35 {\n  padding-right: 35px !important;\n}\n\n.flex-between {\n  display: flex;\n  justify-content: space-between;\n}\n\n.btn-hover {\n  &:hover {\n    color: #17b5d6;\n  }\n}\n\n.text-upper {\n  text-transform: uppercase;\n}\n","$black: #000000;\n$white: #FFFFFF;\n$white-1: #F2F4F9;\n$white-2: #D0D6E5;\n$turquoise: #3697AB;\n$blue-1: #82C6D4;\n$blue-2: #D5EBEF;\n$red-1: #B92C2C;\n$red-2: #FFCFCF;\n$green-1: #12ac6c;\n$green-2: #66C890;\n$green-3: #DDEFD5;\n$green-4: #3DE0A1;\n$orange-1: #F48E62;\n$orange-2: #FEB805;\n$yellow-1: #F4DA62;\n$yellow-2: #FFECAA;\n$dark-blue-1: #13161F;\n$dark-blue-2: #232732;\n$gray-1: #494D5B;\n$gray-2: #747A8E;\n$gray-3: #A6A6A6;\n$gray-4: #6F7B87;\n\n$yellow-0: #F4D115;\n$yellow: #F8C71C;\n$red-0: #F82D46;\n$red: #F24F52;\n$green-0: #42AD7E;\n$orange-0: #F9845A;\n$gray-0: #75899D;\n$blue-0: #3C97AA;\n$blue: #17B5D6;","@import 'src/assets/variables.scss';\n.mt-25 {\n  margin-top: 25px;\n}\n\n.lightbox-wrapper {\n  position: relative;\n  background: rgba(255, 255, 255, 0.6);\n  border: 1px solid transparent;\n  cursor: zoom-in;\n}\n\n.user-avatar {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n}\n\n.disabled-button {\n  pointer-events: none;\n}\n\n.info-item {\n  margin-bottom: 8px;\n  position: relative;\n  &--label {\n    font-size: 10px;\n    line-height: 12px;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: #75899d;\n    display: block;\n  }\n  &--value {\n    font-size: 12px;\n    line-height: 14px;\n    color: #000000;\n    position: relative;\n    margin-top: 3px;\n    padding: 11px 18px 12px 10px;\n    background: #f6f7fa;\n    border-radius: 5px;\n\n    b {\n      font-size: 18px;\n      line-height: 21px;\n      letter-spacing: 0.055em;\n    }\n    p {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.modal {\n  &-charts {\n    padding: 25px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background-color: $white;\n    height: 100vh;\n    width: 100%;\n    overflow: scroll;\n\n    @include scrollBar;\n\n    .modal__body {\n      margin-top: 15px;\n    }\n  }\n  &-window {\n    padding: 25px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background-color: $white;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    &:active,\n    &:focus {\n      outline: none !important;\n    }\n\n    &-second {\n      padding: 25px 0 0;\n      .modal__head {\n        min-height: 40px;\n        margin-bottom: 0;\n        position: relative;\n\n        .close-btn {\n          top: 0;\n          right: 25px;\n        }\n      }\n      .modal__body {\n        padding: 35px 51px 0;\n        display: flex;\n        flex: 1;\n        flex-direction: column;\n        align-items: center;\n        &-small {\n          padding: 35px 30px 0;\n        }\n        &-title {\n          font-family: 'Roboto', sans-serif;\n          font-size: 18px;\n          font-weight: 500;\n          line-height: 20px;\n          text-align: center;\n          text-transform: uppercase;\n          letter-spacing: 0.25px;\n          color: #000000;\n          margin-bottom: 35px;\n\n          &--extra {\n            font-family: 'Roboto', sans-serif;\n            font-size: 16px;\n            font-weight: 400;\n            line-height: 24px;\n            text-align: center;\n            text-transform: none;\n            letter-spacing: 0.5px;\n            color: #797f89;\n            display: block;\n            margin: 25px auto 0;\n          }\n\n          .subtitle-text {\n            font-size: 18px;\n            line-height: 20px;\n          }\n\n          &--extra-info {\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 16px;\n            color: #797f89;\n            margin-top: 20px;\n          }\n        }\n\n        .confirm-text {\n          font-size: 16px;\n          line-height: 21px;\n          color: #797f89;\n          text-align: center;\n\n          b {\n            color: #4a4a4a;\n            font-weight: 500;\n          }\n        }\n        .confirm-user {\n          font-family: 'Roboto', sans-serif;\n          font-size: 14px;\n          font-weight: 500;\n          line-height: 12px;\n          letter-spacing: 0.02em;\n          text-transform: uppercase;\n          color: #222222;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          width: 100%;\n          margin-top: 30px;\n          padding: 10px 15px;\n          border: 1px solid #fdc526;\n          border-radius: 5px;\n\n          img {\n            width: 32px;\n            height: 32px;\n            margin-right: 20px;\n            border: 1px solid #dde0e9;\n            border-radius: 50%;\n          }\n        }\n        .form-control-item > label {\n          display: block;\n          margin-bottom: 8px;\n        }\n      }\n      .modal__footer {\n        padding: 0 51px 35px;\n        display: flex;\n        flex-direction: column;\n\n        .btn-cancel {\n          text-transform: uppercase;\n        }\n\n        .btn-confirm {\n          margin-bottom: 20px;\n        }\n      }\n    }\n\n    &-auto {\n      width: auto;\n      height: auto;\n    }\n    &-big {\n      width: 1024px;\n      height: 570px;\n      &.completion-report-modal {\n        @media (max-width: 1025px) {\n          width: 100%;\n          max-height: 500px;\n          overflow-x: scroll;\n        }\n      }\n    }\n    &-medium {\n      width: 720px;\n      height: 510px;\n\n      &-special {\n        width: 696px;\n        height: 447px;\n        padding-top: 20px;\n\n        .modal__head {\n          &-title {\n            line-height: 21px;\n          }\n          &.simple-head {\n            padding-bottom: 22px;\n            &::before {\n              width: calc(100% + 50px);\n              left: -25px;\n              right: -25px;\n            }\n            &::after {\n              left: -25px;\n            }\n          }\n        }\n      }\n      &.sensor-replace {\n        @media (max-width: 701px) {\n          width: 100%;\n          height: auto;\n        }\n      }\n      &.create-ai {\n        .modal__body {\n          @media (max-width: 500px) {\n            overflow-x: scroll;\n          }\n        }\n        @media (max-width: 701px) {\n          width: 100%;\n          height: auto;\n        }\n      }\n    }\n    &-small {\n      width: 372px;\n      height: 464px;\n      @media (max-width: 372px) {\n        width: 100%;\n      }\n    }\n    &-confirm {\n      width: 375px;\n      height: 465px;\n      @media (max-width: 375px) {\n        width: 100%;\n      }\n    }\n    .modal-extra-line {\n      background-color: #fafafb;\n      margin-left: -24px;\n      margin-right: -24px;\n      padding: 11px 25px 12px;\n      border-top: 1px solid #dde0e9;\n      border-bottom: 1px solid #dde0e9;\n\n      span {\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 15px;\n        color: #6f7b87;\n        display: block;\n\n        .btn-extra {\n          top: 10px;\n        }\n      }\n    }\n    .btn-next {\n      width: 160px;\n    }\n  }\n\n  &__head {\n    position: relative;\n    margin-bottom: 17px;\n\n    &-title {\n      font-family: 'Roboto', sans-serif;\n      font-size: 18px;\n      font-weight: 500;\n      line-height: 21px;\n      text-transform: uppercase;\n      color: #000000;\n      display: flex;\n      align-items: center;\n      @media (max-width: 500px) {\n        flex-direction: column;\n        align-items: start;\n      }\n      .progress-bar-block {\n        @media (max-width: 500px) {\n          margin-left: 0;\n        }\n      }\n    }\n    &-description {\n      font-size: 12px;\n      line-height: 18px;\n      color: #c7cddd;\n    }\n\n    &-extra {\n      font-size: 12px;\n      line-height: 24px;\n      color: #797f89;\n      margin: 20px -25px 0;\n      padding: 10px 28px;\n      background-color: #fafafb;\n      border-top: 1px solid #dde0e9;\n      border-bottom: 1px solid #dde0e9;\n    }\n\n    &.simple-head {\n      position: relative;\n\n      &::before {\n        content: '';\n        width: 100%;\n        height: 1px;\n        background-color: #ececec;\n        position: absolute;\n        left: 0;\n        bottom: 0;\n      }\n\n      &::after {\n        content: '';\n        width: 42px;\n        height: 3px;\n        background-color: #fcc201;\n        position: absolute;\n        left: 0;\n        bottom: -1.5px;\n      }\n    }\n\n    .close-btn {\n      position: absolute;\n      top: 0;\n      right: 0;\n    }\n  }\n  &-form-steps {\n    background-color: #fafafb;\n    margin-left: -24px;\n    margin-right: -24px;\n    padding: 12px 25px;\n    border-top: 1px solid #dde0e9;\n    border-bottom: 1px solid #dde0e9;\n\n    .step-name-item {\n      font-size: 10px;\n      font-weight: 400;\n      line-height: 12px;\n      letter-spacing: 0.05em;\n      text-transform: uppercase;\n      color: #6f7b87;\n      position: relative;\n      cursor: pointer;\n      &:not(:last-child) {\n        margin-right: 15px;\n        padding-right: 18px;\n      }\n\n      &.is-active {\n        font-size: 12px;\n        font-weight: 500;\n        color: #4a4a4a;\n        cursor: auto;\n      }\n\n      .arrow-next {\n        position: absolute;\n        top: 50%;\n        right: 0;\n        transform: translateY(-50%);\n      }\n    }\n  }\n  &__body {\n    flex: 1;\n    height: 100%;\n  }\n  &__footer {\n    margin-top: 30px;\n  }\n  &-step {\n    height: 100%;\n    padding-top: 25px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    .step-title {\n      font-size: 18px;\n      font-weight: 500;\n      line-height: 21px;\n      text-transform: uppercase;\n      margin-top: 20px;\n    }\n\n    .form-step__footer {\n      flex: 0 0 45px;\n      .btn:last-child {\n        margin-left: 25px;\n      }\n    }\n  }\n}\n\n.scroll-y {\n  overflow-y: scroll;\n}\n\n.extra-block {\n  padding: 12px 0;\n  border-top: 1px solid #ededed;\n\n  span > svg {\n    margin-left: 6px;\n  }\n}\n\n.block {\n  &__title {\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 12px;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: #75899d;\n    margin-bottom: 7px;\n\n    &.no-title {\n      min-height: 12px;\n    }\n  }\n}\n\n.ai {\n  &__title {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 24px;\n    color: $white;\n    max-width: 360px;\n    margin-left: -25px;\n    margin-right: 20px;\n    padding: 6px 25px;\n    text-transform: uppercase;\n    &.font-smaller {\n      font-size: 13px;\n      line-height: 16px;\n    }\n    &.title-1 {\n      background-color: $yellow;\n    }\n    &.title-2 {\n      background-color: $orange-0;\n    }\n    &.title-3 {\n      background-color: $red;\n    }\n  }\n}\n\n.btn-block {\n  &-end {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n\n    .btn {\n      margin-left: 26px;\n    }\n  }\n  &-between {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .btn {\n      margin-left: 26px;\n    }\n  }\n}\n\n.pos-tr {\n  position: absolute;\n  top: 0;\n  right: 0;\n  cursor: pointer;\n}\n\n.not-change {\n  pointer-events: none;\n  label {\n    color: #75899d;\n  }\n  input {\n    color: #75899d !important;\n  }\n}\n\n.body-extra-panel {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  padding: 25px;\n  background: #fdfdfd;\n  box-shadow: 0 0 1px rgba(12, 26, 75, 0.24);\n  &__right {\n    @media (max-width: 1366px) {\n      flex-wrap: wrap;\n    }\n    .btn-extra {\n      @media (max-width: 992px) {\n        padding-top: 20px;\n      }\n    }\n    .form-control-item,\n    .filter-search {\n      @media (max-width: 560px) {\n        width: 99%;\n      }\n    }\n\n    @media (max-width: 500px) {\n      flex-direction: column;\n    }\n  }\n  @media (max-width: 640px) {\n    justify-content: center;\n  }\n\n  .title {\n    @include small-text;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: #6f7b87;\n  }\n\n  .subtitle {\n    @include big-text;\n    font-weight: 500;\n    letter-spacing: 0.03em;\n    color: #000000;\n    margin-top: 3px;\n  }\n\n  .page-title {\n    flex-shrink: 0;\n  }\n\n  &.extra-info {\n    justify-content: flex-start;\n    span {\n      @include small-text;\n      letter-spacing: 0.05em;\n      text-transform: uppercase;\n      color: #6f7b87;\n    }\n  }\n}\n\n.start-adornment {\n  @include medium-text;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #75899d;\n  white-space: nowrap;\n  padding-right: 5px;\n}\n\n.page-secondary {\n  background-color: #fafafb;\n\n  &__body {\n    padding: 25px 25px 0;\n    background-color: #fafafb;\n    @media (max-width: 800px) {\n      height: auto;\n    }\n\n    &-left {\n      padding-right: 1px;\n      display: grid;\n      grid-row-gap: 25px;\n    }\n\n    &.page-secondary-print {\n      display: block;\n    }\n\n    .grid-block {\n      padding: 1px;\n      &-container {\n        padding: 25px;\n        height: 100%;\n        background-color: $white;\n        box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05);\n        filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n      }\n    }\n  }\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    padding: 25px;\n    background-color: #fafafb;\n\n    .btn {\n      width: 100%;\n      max-width: 195px;\n      border-radius: 0;\n      &:not(:first-child) {\n        margin-left: 25px;\n      }\n    }\n  }\n}\n\n.text-right {\n  text-align: right;\n}\n\n.swiper {\n  &-button {\n    &-next,\n    &-prev {\n      height: 100%;\n\n      &::after {\n        content: '';\n        background: url('./svg/arrow-next.svg') center no-repeat;\n        background-size: 8px;\n        width: 8px;\n        height: 10px;\n        z-index: 999;\n      }\n    }\n    &-next {\n      right: -10px;\n    }\n    &-prev {\n      left: -10px;\n      &::after {\n        transform: rotate(180deg);\n      }\n    }\n  }\n}\n\n.empty-locations-block {\n  width: 100%;\n  height: 100%;\n  max-height: 320px;\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: #fbfbfb;\n  box-shadow: 0 0 1px rgba(12, 26, 75, 0.24);\n  &-hide {\n    display: none;\n  }\n  p {\n    font-size: 10px;\n    line-height: 12px;\n    text-align: center;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: #75899d;\n    margin-bottom: 20px;\n  }\n\n  span {\n    font-size: 12px;\n    line-height: 20px;\n    text-align: center;\n    color: #797f89;\n    max-width: 210px;\n  }\n}\n\n.checked-list {\n  &__info {\n    padding-top: 18px;\n    padding-bottom: 20px;\n\n    .selected {\n      font-size: 10px;\n      line-height: 12px;\n      letter-spacing: 0.05em;\n      text-transform: uppercase;\n      color: #75899d;\n    }\n  }\n}\n\n.close-fullscreen-chart {\n  margin-left: 5px;\n}\n\n.table-infinity-scroll {\n  position: relative;\n  .table-total-after {\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 12px;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: #6f7b87;\n    position: absolute;\n    left: 0;\n    bottom: -40px;\n  }\n}\n\n.attachments-image {\n  img {\n    width: 100% !important;\n    height: 100%;\n    object-fit: contain;\n  }\n}\n\n.button-block {\n  display: flex;\n}\n\n.translates {\n  &-btn {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 12px;\n    text-transform: capitalize;\n    display: flex;\n    align-items: center;\n    position: absolute;\n    top: -7px;\n    right: 15px;\n    @media (max-width: 810px) {\n      top: 0;\n    }\n    &.translates-text-btn {\n      position: relative;\n      right: 0;\n    }\n    svg {\n      @media (max-width: 810px) {\n        width: 18px;\n      }\n    }\n    &.report-translates-field {\n      font-size: 10px;\n      line-height: 10px;\n      top: 12px;\n      right: 0;\n\n      svg {\n        width: 20px;\n      }\n      .btn-extra {\n        margin-left: 5px;\n      }\n    }\n\n    .btn-extra {\n      margin-left: 10px;\n      @media (max-width: 1281px) {\n        font-size: 10px;\n        margin-left: 5px;\n      }\n    }\n  }\n}\n\n.not-click {\n  cursor: auto;\n  pointer-events: none;\n}\n\n.recently-viewed-mark {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  color: #b6bbc7;\n}\n\n.datepicker-with-time {\n  width: 330px;\n\n  .react-datepicker__time-list {\n    @include scrollBar;\n  }\n}\n.btn-link.support-link {\n  font-size: 16px;\n  font-weight: 500;\n  color: #3694a8;\n  text-decoration: none;\n}\n.header-troubleshooting-icon {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n}\n.treeselect-field {\n  &.filter-treeselect {\n    flex-direction: row;\n    align-items: center;\n    padding: 0;\n    background: #f6f7fa;\n\n    label {\n      font-size: 10px;\n      font-weight: 400;\n      line-height: 12px;\n      color: #75899d;\n      letter-spacing: 0.5px;\n      text-transform: uppercase;\n      margin-bottom: 0;\n      padding-left: 14px;\n    }\n\n    .ant-select {\n      &.ant-select-focused {\n        .ant-select-selector {\n          box-shadow: none !important;\n        }\n      }\n      &-selector {\n        height: 35px;\n        padding: 12px 0 11px;\n        background-color: transparent;\n        border: none !important;\n        box-shadow: none !important;\n\n        .ant-select-selection-item {\n          font-family: 'Roboto', sans-serif;\n          font-size: 10px;\n          font-weight: 600;\n          line-height: 12px;\n          color: #000;\n          letter-spacing: 0.5px;\n          text-transform: uppercase;\n          padding-inline-end: 20px !important;\n        }\n      }\n      &-arrow {\n        inset-inline-end: 12px;\n      }\n    }\n\n    &.select-location {\n      .ant-tree-select {\n        max-width: 160px;\n      }\n    }\n  }\n\n  &__list {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-right: 0;\n    border-radius: 0;\n    box-shadow: none;\n    filter: drop-shadow(0px 3px 8px rgba(50, 50, 71, 0.05)) drop-shadow(0px 0px 1px rgba(12, 26, 75, 0.24));\n    .ant-select-tree-treenode {\n      width: 100%;\n      align-items: center !important;\n      padding-right: 17px !important;\n\n      .ant-select-tree-switcher {\n        width: 20px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n      .ant-select-tree-indent-unit {\n        width: 20px;\n      }\n    }\n    .ant-select-tree-node {\n      &-content-wrapper {\n        font-family: 'Roboto', sans-serif !important;\n        font-size: 10px;\n        line-height: 12px !important;\n        color: #6b7682 !important;\n        letter-spacing: 0.5px;\n        text-transform: uppercase;\n        position: relative;\n        min-height: 12px !important;\n        padding: 14px 0 12px !important;\n\n        &:hover {\n          background-color: transparent !important;\n        }\n\n        &::after {\n          content: '';\n          width: 100%;\n          height: 1px;\n          background-color: rgba(171, 191, 210, 0.5);\n          position: absolute;\n          bottom: 0;\n          left: 0px;\n        }\n      }\n      &-selected {\n        font-weight: 600;\n        color: #242424 !important;\n        background-color: transparent !important;\n      }\n    }\n    .ant-select-tree-list-scrollbar-thumb {\n      width: 6px !important;\n      background-color: rgba(0, 0, 0, 0.2) !important;\n    }\n  }\n}\n\n.body-rtl {\n  .start-adornment {\n    padding-right: 14px;\n  }\n  .modal__head-title {\n    direction: rtl;\n  }\n  .modal__head .close-btn {\n    left: 0;\n    right: unset;\n  }\n  .btn-block-end .btn {\n    margin-right: 26px;\n    margin-left: 0;\n  }\n}\n","@import 'src/assets/variables.scss';\n\n.body-rtl {\n  direction: rtl;\n  .view,\n  .table-view,\n  .root-view {\n    margin-right: 0 !important;\n    margin-left: -15px !important;\n    -webkit-overflow-scrolling: auto !important;\n  }\n  .type-label-1 {\n    border-right: 4px solid $yellow-1;\n    border-left: none;\n    &:hover {\n      &::after {\n        right: -11px;\n        left: unset;\n      }\n    }\n  }\n  .type-label-2 {\n    border-right: 4px solid $orange-1;\n    border-left: none;\n    &:hover {\n      &::after {\n        left: unset;\n        right: -21px;\n      }\n    }\n  }\n  .type-label-3 {\n    position: relative;\n    border-right: 4px solid $red-1;\n    border-left: none;\n    &:hover {\n      &::after {\n        left: unset;\n        right: -11px;\n      }\n    }\n  }\n  .type-label-4 {\n    border-right: 4px solid $red-1;\n    border-left: none;\n    &:hover {\n      &::after {\n        left: unset;\n        right: -11px;\n      }\n    }\n  }\n  .search {\n    padding-right: 12px;\n    margin-right: 10px;\n  }\n  .search-clear {\n    right: unset;\n    left: 14px;\n  }\n  .search.show-search {\n    padding-right: 16px;\n  }\n  .add-action-item {\n    margin-right: 30px;\n    margin-left: unset;\n  }\n  .type-critical,\n  .type-standard,\n  .type-high {\n    margin-right: 20px;\n    margin-left: 6px;\n  }\n  .custom-filter__single-value {\n    margin-right: 50px;\n  }\n\n\n  .company-saving.ps-5 {\n    padding-left: unset !important;\n    padding-right: 3rem !important;\n  }\n\n  .main-filter .filter-select {\n    margin-right: 15px;\n    margin-left: unset;\n  }\n  &.modal-side .modal-content {\n    margin-left: unset;\n    margin-right: auto;\n  }\n  &.modal-side .modal-header {\n    padding: 30px 30px 20px 20px !important;\n  }\n  .main-filter .filter-select .custom-filter__single-value {\n    margin-right: 42px;\n  }\n  &.modal-fullwidth {\n    margin-right: 250px;\n  }\n  .selection-text {\n    margin-right: 10px;\n    margin-left: unset;\n  }\n  .reports-icon-doc::before,\n  .reports-icon-file::before {\n    right: -29px;\n    left: unset;\n  }\n  &.modal-fullwidth.modal-side {\n    margin-left: 0;\n    margin-right: auto;\n  }\n  &.modal-dialog.modal-fullwidth.ai-fullwidth {\n    margin-right: 200px;\n  }\n  .drawer-view {\n    margin-left: -15px;\n    margin-right: unset;\n  }\n  .form-check-label {\n    margin-right: 10px;\n  }\n  .profileInfo,\n  .custom-btn.btn-submit {\n    margin-right: 20px;\n  }\n  .location-wrapper span {\n    right: unset !important;\n    left: 0;\n  }\n  .input-urgency-1 {\n    margin-right: 15px;\n  }\n  .input-urgency-2 {\n    margin-right: 27px;\n  }\n  .info-title {\n    padding-right: 30px;\n  }\n  .fullscreen-btn {\n    right: unset;\n    left: 9px;\n  }\n  .event-input .form-check-input {\n    float: left !important;\n  }\n  .charts-btn {\n    transform: rotate(180deg);\n  }\n  .change-theme-icon {\n    transform: rotate(220deg);\n    margin-left: 5px;\n  }\n  //.logout-icon {\n  //  transform: rotate(180deg);\n  //  margin-left: 10px;\n  //}\n  .saving-icon {\n    margin-right: 0;\n    margin-left: 10px;\n  }\n  .saving-block {\n    margin-right: 0;\n    margin-left: 10px;\n  }\n  .filter-item {\n    margin-right: 0;\n    margin-left: 20px;\n  }\n\n  .comment-controls {\n    top: 20px;\n    right: 5px;\n  }\n  .ai-label {\n    margin-right: 10px;\n  }\n  .attach-icon {\n    margin-right: 0;\n    margin-left: 10px;\n  }\n  &.modal-fullwidth .modal-header {\n    padding: 30px 30px 20px 30px !important;\n  }\n  .header-close {\n    margin-right: 10px;\n  }\n  .full-btn {\n    margin-right: 0;\n  }\n  &.modal-fullwidth .advance-search {\n    right: unset;\n    left: 0;\n  }\n}\n","@import 'src/assets/variables.scss';\n\nbody .add-action-item:hover,\n.btn-check:checked + .btn-secondary:focus,\n.btn-check:active + .btn-secondary:focus,\n.btn-secondary:active:focus,\n.btn-secondary.active:focus,\n.show > .btn-secondary.dropdown-toggle:focus,\n.btn-check:focus + .btn-secondary,\n.btn-secondary:focus,\n.btn-check:focus + .btn,\n.btn:focus {\n  box-shadow: none;\n}\n\n* {\n  font-family: 'Roboto', sans-serif;\n  box-sizing: border-box;\n}\n\nbody {\n  font-size: 12px;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n\n  @include scrollBar;\n\n  .view {\n    background-color: #fafafb;\n    overflow-y: scroll !important;\n\n    &.onboard {\n      position: relative !important;\n    }\n  }\n\n  .page-title {\n    font-family: 'Roboto', sans-serif;\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 1;\n  }\n\n  .container-block {\n    background-color: #f5f5f5;\n    padding: 25px;\n\n    @media (max-width: 800px) {\n      padding: 25px 15px;\n    }\n\n    &.full-height {\n      min-height: calc(100vh - 170px);\n    }\n  }\n\n  .custom-filter__indicator.custom-filter__dropdown-indicator {\n    svg {\n      fill: $dark-blue-2;\n\n      path {\n        fill: $dark-blue-2;\n      }\n    }\n  }\n\n  .page-title {\n    color: #000000;\n  }\n}\n\n.tooltip {\n  background: var(--tables-secondary-row-sub-title-surface);\n\n  span {\n    color: var(--title-inputs-sections-title) !important;\n  }\n\n  b {\n    color: var(--tables-primary-row-text-main);\n    fill: var(--tables-primary-row-text-main);\n  }\n\n  path {\n    fill: var(--tables-secondary-row-sub-title-surface);\n  }\n\n  text {\n    fill: var(--tables-secondary-row-sub-title-text) !important;\n  }\n\n  tspan {\n    color: var(--tables-primary-row-text-main);\n    fill: var(--tables-primary-row-text-main);\n  }\n\n}\n\n.track-margin {\n  height: calc(100% - 50px);\n  top: 50px;\n  right: 3px;\n  border-radius: 3px;\n}\n\n.link-color {\n  color: #3c97aa !important;\n}\n\ndiv.react-tooltip {\n  font-family: 'Roboto', sans-serif;\n  font-size: 14px;\n  line-height: 16px;\n  font-weight: 400;\n  text-align: center;\n  text-transform: initial;\n  letter-spacing: 0;\n  z-index: 9;\n}\n\n.disabled-mark {\n  width: 6px;\n  height: 6px;\n  flex-shrink: 0;\n  margin-left: 20px;\n  background-color: #fdc526;\n  border-radius: 50%;\n}\n\n.text-lowercase {\n  text-transform: lowercase;\n}\n\n.tooltip-size-medium {\n  max-width: 450px;\n}\n\n.empty-block-table {\n  position: absolute;\n  top: 45px;\n  left: 50%;\n  transform: translateX(-50%);\n\n  span {\n    font-size: 12px;\n    text-transform: uppercase;\n    color: #6f7b87;\n    text-align: center;\n    padding: 17px 25px;\n  }\n}\n\n#react-refresh-overlay {\n  display: none;\n}\n\n.ml-40 {\n  margin-left: 40px;\n}\n",":root {\n  --blue-neutral-blue-20: #d0e0e9;\n  --blue-neutral-blue-30: #c7cddd;\n  --blue-neutral-blue-40: #c4c9dd;\n  --blue-neutral-blue-50: #a8acb7;\n  --blue-neutral-blue-60: #75899d;\n  --blue-neutral-blue-70: #797f89;\n  --dark-accent-blue-primary: #51d5ff;\n  --dark-accent-blue-primary-disable: #799ba8;\n  --dark-accent-blue-primary-focused: #1aa8e0;\n  --dark-accent-blue-primary-hovered: #30c4ff;\n  --dark-accent-blue-secondary: #044154;\n  --dark-accent-blue-10: #1d76ca;\n  --dark-accent-blue-20: #2f4a5a;\n  --dark-accent-bumblebee: #f0d980;\n  --dark-accent-green-10: #35b37c;\n  --dark-accent-green-20: #3a4f46;\n  --dark-accent-orange: #fcb141;\n  --dark-accent-papaya-urgency: #f9845a;\n  --dark-accent-red-10: #f34b4b;\n  --dark-accent-red-20: #5a2f2f;\n  --dark-accent-red-5: #461e1e;\n  --grey-black: #000000;\n  --grey-grey-10: #ededef;\n  --grey-grey-100: #181818;\n  --grey-grey-15: #cccbcb;\n  --grey-grey-20: #b2b2b2;\n  --grey-grey-25: #999999;\n  --grey-grey-30: #c4c9dd;\n  --grey-grey-35: #a8acb7;\n  --grey-grey-40: #6b7682;\n  --grey-grey-45: #6e7076;\n  --grey-grey-5: #e0e2e6;\n  --grey-grey-50: #797f89;\n  --grey-grey-50-2: #797f8980;\n  --grey-grey-55: #4a4a4a;\n  --grey-grey-60: #414141;\n  --grey-grey-65: #343539;\n  --grey-grey-70: #2c2d31;\n  --grey-grey-75: #2c2c2c;\n  --grey-grey-80: #27282b;\n  --grey-grey-85: #262626;\n  --grey-grey-90: #222222;\n  --grey-grey-95: #1f1f1f;\n  --grey-grey-95-2: #1f1f1fcc;\n  \n  --light-accent-blue-primary: #3c97aa;\n  --light-accent-blue-primary-disabled: #b0bfc3;\n  --light-accent-blue-primary-focused: #2b7e8e;\n  --light-accent-blue-primary-hover: #50afc0;\n  --light-accent-blue-secondary: #ecffff;\n  --light-accent-blue-10: #d9eaf7;\n  --light-accent-blue-20: #1d76ca;\n  --light-accent-bumblebee: #f8c71c;\n  --light-accent-green-10: #e3ede9;\n  --light-accent-green-20: #42ad7e;\n  --light-accent-orange: #f89b11;\n  --light-accent-papaya: #ff7300;\n  --light-accent-red-10: #f7d9d9;\n  --light-accent-red-20: #f24f52;\n  --light-accent-red-5: #fff4f4;\n  --neutrals-neutral-10: #fcfcfd;\n  --neutrals-neutral-100: #d0e0e9;\n  --neutrals-neutral-20: #f6f7fa;\n  --neutrals-neutral-30: #fafafb;\n  --neutrals-neutral-30-1: #fafafbcc;\n  --neutrals-neutral-40: #f2f2f2;\n  --neutrals-neutral-50: #ececec;\n  --neutrals-neutral-60: #e4e4e4;\n  --neutrals-neutral-70: #d3d3d3;\n  --neutrals-neutral-80: #b6bbc7;\n  --neutrals-neutral-90: #dde0e9;\n  --neutrals-white: #ffffff;\n\n  --yellow-yellow-100: #fff3d4;\n  --yellow-yellow-200: #fee8a8;\n  --yellow-yellow-300: #fedc7d;\n  --yellow-yellow-400: #fdd151;\n  --yellow-yellow-500: #fdc526;\n  --yellow-yellow-600: #fcc201;\n  --yellow-yellow-700: #b37400;\n\n  --yellow-yellow-80: #fffbf0;\n  --yellow-yellow-90: #38362f;\n}\n",":root {\n  --inputs-default-icon: var(--neutrals-neutral-80, #b6bbc7);\n  --inputs-default-placeholder: var(--neutrals-neutral-80, #b6bbc7);\n  --inputs-default-stroke: var(--grey-grey-10, #ededef);\n  --inputs-default-surface-default: var(--neutrals-white, #ffffff);\n  --inputs-default-text: var(--grey-grey-50, #797f89);\n  --inputs-disable-disable-surface: var(--neutrals-neutral-40, #f2f2f2);\n  --inputs-disable-icon: var(--neutrals-neutral-80, #b6bbc7);\n  --inputs-disable-stroke: var(--neutrals-neutral-30, #fafafb);\n  --inputs-disable-text: var(--grey-grey-45, #6e7076);\n  --inputs-error-error-surface: var(--neutrals-white, #ffffff);\n  --inputs-error-stroke: var(--light-accent-red-20, #f24f52);\n  --inputs-error-text: var(--grey-black, #000000);\n  --inputs-error-text-helper: var(--light-accent-red-20, #f24f52);\n  --inputs-filled-filled-surface: var(--neutrals-white, #ffffff);\n  --inputs-filled-icon: var(--neutrals-neutral-80, #b6bbc7);\n  --inputs-filled-stroke: var(--neutrals-neutral-80, #b6bbc7);\n  --inputs-filled-text: var(--grey-black, #000000);\n  --inputs-focus-icon: var(--neutrals-neutral-80, #b6bbc7);\n  --inputs-focus-stroke: var(--light-accent-blue-primary, #3c97aa);\n  --inputs-focus-surface-focus: var(--neutrals-white, #ffffff);\n  --inputs-focus-text: var(--grey-black, #000000);\n  --inputs-search-icon: var(--light-accent-blue-primary, #3c97aa);\n  --inputs-search-surface-default: var(--neutrals-white, #ffffff);\n  --inputs-search-surface-table: var(--neutrals-neutral-30, #fafafb);\n  --inputs-search-text-filled: var(--grey-grey-55, #4a4a4a);\n  --inputs-search-text-placeholer: var(--blue-neutral-blue-50, #a8acb7);\n  --brand-logo: var(--grey-black, #000000);\n  --brand-logo-surface: var(--yellow-yellow-600, #fcc201);\n  --brand-logo-surface-hover: var(--yellow-yellow-300, #fedc7d);\n  --brand-waites: var(--neutrals-white, #ffffff);\n  --buttons-disable: var(--light-accent-blue-primary-disabled, #b0bfc3);\n  --buttons-disable-2: var(--light-accent-blue-primary-disabled, #b0bfc3);\n  --buttons-focused: var(--light-accent-blue-primary-focused, #2b7e8e);\n  --buttons-hover: var(--light-accent-blue-primary-hover, #50afc0);\n  --buttons-stroke: var(--light-accent-blue-primary, #3c97aa);\n  --buttons-surface: var(--light-accent-blue-primary, #3c97aa);\n  --buttons-surface-2: var(--light-accent-blue-primary, #3c97aa);\n  --buttons-text-additional: var(--grey-black, #000000);\n  --buttons-text-primary: var(--neutrals-white, #ffffff);\n  --buttons-text-secondary: var(--light-accent-blue-primary, #3c97aa);\n  --calendar-day-selected: var(--light-accent-blue-secondary, #ecffff);\n  --calendar-stroke: var(--grey-grey-10, #ededef);\n  --calendar-surface-row: var(--neutrals-white, #ffffff);\n  --calendar-surface-title: var(--neutrals-neutral-30, #fafafb);\n  --calendar-text-icon-default: var(--grey-grey-55, #4a4a4a);\n  --calendar-text-icon-disable: var(--neutrals-neutral-80, #b6bbc7);\n  --calendar-text-icon-selected: var(--light-accent-blue-primary, #3c97aa);\n  --context-menu-icon: var(--light-accent-blue-primary, #3c97aa);\n  --context-menu-stroke: var(--grey-grey-10, #ededef);\n  --context-menu-surface: var(--neutrals-white, #ffffff);\n  --context-menu-text: var(--grey-grey-45, #6e7076);\n  --header-elevation: var(--neutrals-neutral-30, #fafafb);\n  --header-icon-main: var(--blue-neutral-blue-60, #75899d);\n  --header-icon-secondary: var(--blue-neutral-blue-70, #797f89);\n  --header-search: var(--blue-neutral-blue-50, #a8acb7);\n  --header-stroke: var(--grey-grey-10, #ededef);\n  --header-surface: var(--neutrals-white, #ffffff);\n  --header-title-main: var(--grey-black, #000000);\n  --header-title-secondary: var(--blue-neutral-blue-60, #75899d);\n  --labels-filled-stroke-archived: var(--neutrals-neutral-80, #b6bbc7);\n  --labels-filled-stroke-caution: var(--light-accent-orange, #f89b11);\n  --labels-filled-stroke-inactive: var(--neutrals-neutral-100, #d0e0e9);\n  --labels-filled-surface-archived: var(--neutrals-neutral-80, #b6bbc7);\n  --labels-filled-surface-caution: var(--yellow-yellow-100, #fff3d4);\n  --labels-filled-surface-count: var(--neutrals-white, #ffffff);\n  --labels-filled-surface-critical: var(--light-accent-red-20, #f24f52);\n  --labels-filled-surface-empty: var(--neutrals-neutral-90, #dde0e9);\n  --labels-filled-surface-high: var(--light-accent-papaya, #ff7300);\n  --labels-filled-surface-inactive: var(--neutrals-white, #ffffff);\n  --labels-filled-surface-standard: var(--light-accent-bumblebee, #f8c71c);\n  --labels-filled-surface-warning: var(--light-accent-red-10, #f7d9d9);\n  --labels-filled-text: var(--neutrals-white, #ffffff);\n  --labels-filled-text-archived: var(--neutrals-white, #ffffff);\n  --labels-filled-text-reversed-white: var(--neutrals-white, #ffffff);\n  --labels-outline-stroke-text-archived: var(--neutrals-neutral-80, #b6bbc7);\n  --labels-outline-stroke-text-critical: var(--light-accent-red-20, #f24f52);\n  --labels-outline-stroke-text-high: var(--light-accent-papaya, #ff7300);\n  --labels-outline-stroke-text-standard: var(--light-accent-bumblebee, #f8c71c);\n  --labels-outline-stroke-text-success: var(--light-accent-green-20, #42ad7e);\n  --labels-outline-surface: var(--neutrals-white, #ffffff);\n  --labels-outline-text-standard: var(--yellow-yellow-700, #b37400);\n  --legend-for-header-critical: var(--light-accent-red-20, #f24f52);\n  --legend-for-header-high: var(--light-accent-papaya, #ff7300);\n  --legend-for-header-inactive: var(--neutrals-white, #ffffff);\n  --legend-for-header-inactive-stroke: var(--neutrals-neutral-100, #d0e0e9);\n  --legend-for-header-no-ai: var(--light-accent-green-20, #42ad7e);\n  --legend-for-header-snoozed: var(--grey-grey-10, #ededef);\n  --legend-for-header-snoozed-badge: var(--grey-grey-50, #797f89);\n  --legend-for-header-snoozed-badge-stroke: var(--neutrals-white, #ffffff);\n  --legend-for-header-standard: var(--light-accent-bumblebee, #f8c71c);\n  --legend-for-header-text: var(--grey-grey-55, #4a4a4a);\n  --map-stroke: var(--neutrals-neutral-40, #f2f2f2);\n  --map-surface-click: var(--light-accent-blue-primary-focused, #2b7e8e);\n  --map-surface-default: var(--grey-grey-15, #cccbcb);\n  --map-surface-hover: var(--grey-grey-20, #b2b2b2);\n  --notifications-error-icon-reversed: var(--neutrals-neutral-40, #f2f2f2);\n  --notifications-error-icon-surface: var(--dark-accent-red-10, #f34b4b);\n  --notifications-error-stroke: var(--dark-accent-red-10, #f34b4b);\n  --notifications-error-surface: var(--light-accent-red-10, #f7d9d9);\n  --notifications-error-text: var(--grey-grey-85, #222222);\n  --notifications-info-icon-reversed: var(--neutrals-neutral-40, #f2f2f2);\n  --notifications-info-icon-surface: var(--dark-accent-blue-10, #1d76ca);\n  --notifications-info-stroke: var(--dark-accent-blue-10, #1d76ca);\n  --notifications-info-surface: var(--light-accent-blue-10, #d9eaf7);\n  --notifications-info-text: var(--grey-grey-85, #222222);\n  --notifications-success-icon-reversed: var(--neutrals-neutral-40, #f2f2f2);\n  --notifications-success-icon-surface: var(--dark-accent-green-10, #35b37c);\n  --notifications-success-stroke: var(--dark-accent-green-10, #35b37c);\n  --notifications-success-surface: var(--light-accent-green-10, #e3ede9);\n  --notifications-success-text: var(--grey-grey-85, #222222);\n  --segments-chips-toggle-icon-reversed: var(--neutrals-white, #ffffff);\n  --segments-chips-toggle-stroke-active: var(--light-accent-blue-primary, #3c97aa);\n  --segments-chips-toggle-stroke-default: var(--neutrals-neutral-70, #d3d3d3);\n  --segments-chips-toggle-surface-active: var(--light-accent-blue-secondary, #ecffff);\n  --segments-chips-toggle-surface-default: var(--neutrals-neutral-30, #fafafb);\n  --segments-chips-toggle-text-active: var(--light-accent-blue-primary, #3c97aa);\n  --segments-chips-toggle-text-default: var(--grey-grey-50, #797f89);\n  --selection-controls-checkbox-surface-default: var(--blue-neutral-blue-60, #75899d);\n  --selection-controls-checkbox-surface-disable: var(--light-accent-blue-primary-disabled, #b0bfc3);\n  --selection-controls-checkbox-text: var(--grey-grey-55, #4a4a4a);\n  --selection-controls-checkbox-text-disable: var(--grey-grey-45, #6e7076);\n  --selection-controls-radio-surface-default: var(--blue-neutral-blue-60, #75899d);\n  --selection-controls-radio-surface-disable: var(--light-accent-blue-primary-disabled, #b0bfc3);\n  --selection-controls-radio-text: var(--grey-grey-55, #4a4a4a);\n  --selection-controls-radio-text-disable: var(--grey-grey-45, #6e7076);\n  --selection-controls-toggle-surface-active: var(--light-accent-green-20, #42ad7e);\n  --selection-controls-toggle-surface-default: var(--blue-neutral-blue-60, #75899d);\n  --selection-controls-toggle-surface-disable: var(--light-accent-blue-primary-disabled, #b0bfc3);\n  --selection-controls-toggle-text: var(--grey-grey-55, #4a4a4a);\n  --selection-controls-toggle-text-disable: var(--grey-grey-45, #6e7076);\n  --selection-controls-toggle-thumb-active: var(--neutrals-white, #ffffff);\n  --side-menu-elevation: var(--grey-grey-80, #262626);\n  --side-menu-icon-drop-down: var(--grey-grey-50, #797f89);\n  --side-menu-icon-primary: var(--blue-neutral-blue-30, #c7cddd);\n  --side-menu-icon-secondary: var(--grey-grey-40, #6b7682);\n  --side-menu-name: var(--blue-neutral-blue-20, #d0e0e9);\n  --side-menu-stroke: var(--grey-grey-60, #414141);\n  --side-menu-surface: var(--grey-grey-70, #2c2d31);\n  --side-menu-text-primary: var(--blue-neutral-blue-30, #c7cddd);\n  --side-menu-text-secondary: var(--grey-grey-40, #6b7682);\n  --tables-main-surface: var(--neutrals-neutral-30, #fafafb);\n  --tables-pagination-pagination-active: var(--grey-grey-50, #797f89);\n  --tables-pagination-pagination-disabled: var(--light-accent-blue-primary-disabled, #b0bfc3);\n  --tables-photo-gallery-icon: var(--grey-grey-45, #6e7076);\n  --tables-photo-gallery-pagination-active: var(--light-accent-bumblebee, #f8c71c);\n  --tables-photo-gallery-pagination-default: var(--neutrals-neutral-80, #b6bbc7);\n  --tables-photo-gallery-surface: var(--neutrals-neutral-30, #fafafb);\n  --tables-photo-gallery-surface-arrow: var(--neutrals-neutral-30-1, #fafafbcc);\n  --tables-primary-row-icon: var(--grey-grey-50, #797f89);\n  --tables-primary-row-stroke: var(--grey-grey-10, #ededef);\n  --tables-primary-row-stroke-drag-drop: var(--light-accent-blue-primary, #3c97aa);\n  --tables-primary-row-surface-default: var(--neutrals-white, #ffffff);\n  --tables-primary-row-surface-drag-drop: var(--light-accent-blue-secondary, #ecffff);\n  --tables-primary-row-surface-hover: var(--yellow-yellow-80, #fffbf0);\n  --tables-primary-row-surface-selected: var(--neutrals-neutral-40, #f2f2f2);\n  --tables-primary-row-text-additional: var(--grey-grey-40, #6b7682);\n  --tables-primary-row-text-main: var(--grey-grey-70, #2c2d31);\n  --tables-secondary-row-sub-title-icon: var(--grey-grey-45, #6e7076);\n  --tables-secondary-row-sub-title-surface: var(--neutrals-neutral-30, #fafafb);\n  --tables-secondary-row-sub-title-text: var(--grey-grey-45, #6e7076);\n  --tables-title-icon: var(--neutrals-neutral-80, #b6bbc7);\n  --tables-title-progress-bar: var(--neutrals-neutral-60, #e4e4e4);\n  --tables-title-stroke: var(--neutrals-neutral-90, #dde0e9);\n  --tables-title-surface: var(--neutrals-neutral-30, #fafafb);\n  --tables-title-text: var(--grey-grey-50, #797f89);\n  --tabs-stroke-default: var(--neutrals-neutral-40, #f2f2f2);\n  --tabs-surface-active: var(--neutrals-white, #ffffff);\n  --tabs-surface-default: var(--neutrals-neutral-40, #f2f2f2);\n  --tabs-surface-hover: var(--neutrals-neutral-30, #fafafb);\n  --tabs-text-active: var(--grey-grey-80, #262626);\n  --tabs-text-default: var(--grey-grey-45, #6e7076);\n  --tabs-text-disable: var(--grey-grey-35, #a8acb7);\n  --tabs-text-hover: var(--grey-black, #000000);\n  --title-inputs-sections-drop-down-count: var(--grey-grey-50, #797f89);\n  --title-inputs-sections-required: var(--light-accent-red-20, #f24f52);\n  --title-inputs-sections-surface: var(--neutrals-white, #ffffff);\n  --title-inputs-sections-title: var(--grey-grey-50, #797f89);\n  --errors-and-states-green: var(--light-accent-green-20, #42ad7e);\n  --tables-skeleton-element: var(--neutrals-neutral-60, #e4e4e4);\n  --tables-skeleton-surface-row-2: var(--neutrals-neutral-50, #ececec);\n  /*--GENERATED FROM PLUGIN--*/\n\n  --select-dropdown-box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24),\n    0px 3px 8px -1px rgba(50, 50, 71, 0.05);\n  --modal-box-shadow: 0px 1px 16px -1px rgba(0, 0, 0, 0.15), 1px 2px 8px -1px rgba(65, 65, 65, 0.4);\n  --basic-box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);\n  --info-block-box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);\n  --table-box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);\n  --map-legend-item-background-rgb: 255, 255, 255;\n}\n",".dark {\n  --inputs-default-icon: var(--blue-neutral-blue-50, #a8acb7);\n  --inputs-default-placeholder: var(--grey-grey-50, #797f89);\n  --inputs-default-stroke: var(--grey-grey-65, #343539);\n  --inputs-default-surface-default: var(--grey-grey-65, #343539);\n  --inputs-default-text: var(--neutrals-neutral-80, #b6bbc7);\n  --inputs-disable-disable-surface: var(--grey-grey-80, #27282b);\n  --inputs-disable-icon: var(--blue-neutral-blue-50, #a8acb7);\n  --inputs-disable-stroke: var(--grey-grey-80, #262626);\n  --inputs-disable-text: var(--grey-grey-35, #a8acb7);\n  --inputs-error-error-surface: var(--grey-grey-65, #343539);\n  --inputs-error-stroke: var(--dark-accent-red-10, #f34b4b);\n  --inputs-error-text: var(--neutrals-white, #ffffff);\n  --inputs-error-text-helper: var(--dark-accent-red-10, #f34b4b);\n  --inputs-filled-filled-surface: var(--grey-grey-65, #343539);\n  --inputs-filled-icon: var(--blue-neutral-blue-50, #a8acb7);\n  --inputs-filled-stroke: var(--grey-grey-55, #4a4a4a);\n  --inputs-filled-text: var(--grey-grey-10, #ededef);\n  --inputs-focus-icon: var(--blue-neutral-blue-50, #a8acb7);\n  --inputs-focus-stroke: var(--dark-accent-blue-primary, #51d5ff);\n  --inputs-focus-surface-focus: var(--grey-grey-65, #343539);\n  --inputs-focus-text: var(--neutrals-white, #ffffff);\n  --inputs-search-icon: var(--dark-accent-blue-primary, #51d5ff);\n  --inputs-search-surface-default: var(--grey-grey-70, #2c2d31);\n  --inputs-search-surface-table: var(--grey-grey-80, #27282b);\n  --inputs-search-text-filled: var(--grey-grey-5, #e0e2e6);\n  --inputs-search-text-placeholer: var(--blue-neutral-blue-50, #a8acb7);\n  --brand-logo: var(--grey-black, #000000);\n  --brand-logo-surface: var(--yellow-yellow-600, #fcc201);\n  --brand-logo-surface-hover: var(--yellow-yellow-300, #fedc7d);\n  --brand-waites: var(--neutrals-white, #ffffff);\n  --buttons-disable: var(--dark-accent-blue-primary-disable, #799ba8);\n  --buttons-disable-2: var(--dark-accent-blue-primary-disable, #799ba8);\n  --buttons-focused: var(--dark-accent-blue-primary-focused, #1aa8e0);\n  --buttons-hover: var(--dark-accent-blue-primary-hovered, #30c4ff);\n  --buttons-stroke: var(--dark-accent-blue-primary, #51d5ff);\n  --buttons-surface: var(--dark-accent-blue-primary, #51d5ff);\n  --buttons-surface-2: var(--dark-accent-blue-primary, #51d5ff);\n  --buttons-text-additional: var(--neutrals-white, #ffffff);\n  --buttons-text-primary: var(--grey-black, #000000);\n  --buttons-text-secondary: var(--dark-accent-blue-primary, #51d5ff);\n  --calendar-day-selected: var(--dark-accent-blue-secondary, #044154);\n  --calendar-stroke: var(--grey-grey-60, #414141);\n  --calendar-surface-row: var(--grey-grey-70, #2c2d31);\n  --calendar-surface-title: var(--grey-grey-90, #1f1f1f);\n  --calendar-text-icon-default: var(--grey-grey-5, #e0e2e6);\n  --calendar-text-icon-disable: var(--grey-grey-50, #797f89);\n  --calendar-text-icon-selected: var(--dark-accent-blue-primary, #51d5ff);\n  --context-menu-icon: var(--dark-accent-blue-primary, #51d5ff);\n  --context-menu-stroke: var(--grey-grey-60, #414141);\n  --context-menu-surface: var(--grey-grey-65, #343539);\n  --context-menu-text: var(--neutrals-neutral-60, #e4e4e4);\n  --header-elevation: var(--grey-grey-90, #1f1f1f);\n  --header-icon-main: var(--blue-neutral-blue-40, #c4c9dd);\n  --header-icon-secondary: var(--blue-neutral-blue-50, #a8acb7);\n  --header-search: var(--blue-neutral-blue-50, #a8acb7);\n  --header-stroke: var(--grey-grey-60, #414141);\n  --header-surface: var(--grey-grey-70, #2c2d31);\n  --header-title-main: var(--neutrals-white, #ffffff);\n  --header-title-secondary: var(--blue-neutral-blue-40, #c4c9dd);\n  --labels-filled-stroke-archived: var(--grey-grey-35, #a8acb7);\n  --labels-filled-stroke-caution: var(--dark-accent-orange, #fcb141);\n  --labels-filled-stroke-inactive: var(--neutrals-neutral-100, #d0e0e9);\n  --labels-filled-surface-archived: var(--grey-grey-90, #1f1f1f);\n  --labels-filled-surface-caution: var(--yellow-yellow-100, #fff3d4);\n  --labels-filled-surface-count: var(--grey-grey-70, #2c2d31);\n  --labels-filled-surface-critical: var(--dark-accent-red-10, #f34b4b);\n  --labels-filled-surface-empty: var(--grey-grey-40, #6b7682);\n  --labels-filled-surface-high: var(--dark-accent-papaya-urgency, #f9845a);\n  --labels-filled-surface-inactive: var(--neutrals-white, #ffffff);\n  --labels-filled-surface-standard: var(--dark-accent-bumblebee, #f0d980);\n  --labels-filled-surface-warning: var(--dark-accent-red-20, #5a2f2f);\n  --labels-filled-text: var(--grey-grey-70, #2c2d31);\n  --labels-filled-text-archived: var(--grey-grey-35, #a8acb7);\n  --labels-filled-text-reversed-white: var(--neutrals-white, #ffffff);\n  --labels-outline-stroke-text-archived: var(--grey-grey-35, #a8acb7);\n  --labels-outline-stroke-text-critical: var(--dark-accent-red-10, #f34b4b);\n  --labels-outline-stroke-text-high: var(--dark-accent-papaya-urgency, #f9845a);\n  --labels-outline-stroke-text-standard: var(--dark-accent-bumblebee, #f0d980);\n  --labels-outline-stroke-text-success: var(--dark-accent-green-10, #35b37c);\n  --labels-outline-surface: var(--grey-grey-70, #2c2d31);\n  --labels-outline-text-standard: var(--dark-accent-bumblebee, #f0d980);\n  --legend-for-header-critical: var(--light-accent-red-20, #f24f52);\n  --legend-for-header-high: var(--dark-accent-papaya-urgency, #f9845a);\n  --legend-for-header-inactive: var(--neutrals-white, #ffffff);\n  --legend-for-header-inactive-stroke: var(--neutrals-neutral-100, #d0e0e9);\n  --legend-for-header-no-ai: var(--dark-accent-green-10, #35b37c);\n  --legend-for-header-snoozed: var(--grey-grey-5, #e0e2e6);\n  --legend-for-header-snoozed-badge: var(--neutrals-white, #ffffff);\n  --legend-for-header-snoozed-badge-stroke: var(--grey-grey-70, #2c2d31);\n  --legend-for-header-standard: var(--dark-accent-bumblebee, #f0d980);\n  --legend-for-header-text: var(--grey-grey-5, #e0e2e6);\n  --map-stroke: var(--grey-grey-60, #414141);\n  --map-surface-click: var(--dark-accent-blue-primary-focused, #1aa8e0);\n  --map-surface-default: var(--grey-grey-45, #6e7076);\n  --map-surface-hover: var(--grey-grey-85, #222222);\n  --notifications-error-icon-reversed: var(--neutrals-neutral-40, #f2f2f2);\n  --notifications-error-icon-surface: var(--dark-accent-red-10, #f34b4b);\n  --notifications-error-stroke: var(--dark-accent-red-10, #f34b4b);\n  --notifications-error-surface: var(--dark-accent-red-20, #5a2f2f);\n  --notifications-error-text: var(--neutrals-neutral-40, #f2f2f2);\n  --notifications-info-icon-reversed: var(--neutrals-neutral-40, #f2f2f2);\n  --notifications-info-icon-surface: var(--dark-accent-blue-10, #1d76ca);\n  --notifications-info-stroke: var(--dark-accent-blue-10, #1d76ca);\n  --notifications-info-surface: var(--dark-accent-blue-20, #2f4a5a);\n  --notifications-info-text: var(--neutrals-neutral-40, #f2f2f2);\n  --notifications-success-icon-reversed: var(--neutrals-neutral-40, #f2f2f2);\n  --notifications-success-icon-surface: var(--dark-accent-green-10, #35b37c);\n  --notifications-success-stroke: var(--dark-accent-green-10, #35b37c);\n  --notifications-success-surface: var(--dark-accent-green-20, #3a4f46);\n  --notifications-success-text: var(--neutrals-neutral-40, #f2f2f2);\n  --segments-chips-toggle-icon-reversed: var(--neutrals-white, #ffffff);\n  --segments-chips-toggle-stroke-active: var(--dark-accent-blue-primary, #51d5ff);\n  --segments-chips-toggle-stroke-default: var(--neutrals-neutral-70, #d3d3d3);\n  --segments-chips-toggle-surface-active: var(--dark-accent-blue-secondary, #044154);\n  --segments-chips-toggle-surface-default: var(--grey-grey-90, #1f1f1f);\n  --segments-chips-toggle-text-active: var(--dark-accent-blue-primary, #51d5ff);\n  --segments-chips-toggle-text-default: var(--neutrals-neutral-70, #d3d3d3);\n  --selection-controls-checkbox-surface-default: var(--grey-grey-30, #c4c9dd);\n  --selection-controls-checkbox-surface-disable: var(--dark-accent-blue-primary-disable, #799ba8);\n  --selection-controls-checkbox-text: var(--grey-grey-5, #e0e2e6);\n  --selection-controls-checkbox-text-disable: var(--grey-grey-35, #a8acb7);\n  --selection-controls-radio-surface-default: var(--grey-grey-30, #c4c9dd);\n  --selection-controls-radio-surface-disable: var(--dark-accent-blue-primary-disable, #799ba8);\n  --selection-controls-radio-text: var(--grey-grey-5, #e0e2e6);\n  --selection-controls-radio-text-disable: var(--grey-grey-35, #a8acb7);\n  --selection-controls-toggle-surface-active: var(--dark-accent-green-10, #35b37c);\n  --selection-controls-toggle-surface-default: var(--grey-grey-30, #c4c9dd);\n  --selection-controls-toggle-surface-disable: var(--dark-accent-blue-primary-disable, #799ba8);\n  --selection-controls-toggle-text: var(--grey-grey-5, #e0e2e6);\n  --selection-controls-toggle-text-disable: var(--grey-grey-35, #a8acb7);\n  --selection-controls-toggle-thumb-active: var(--grey-grey-70, #2c2d31);\n  --side-menu-elevation: var(--grey-grey-80, #262626);\n  --side-menu-icon-drop-down: var(--grey-grey-50, #797f89);\n  --side-menu-icon-primary: var(--blue-neutral-blue-30, #c7cddd);\n  --side-menu-icon-secondary: var(--grey-grey-40, #6b7682);\n  --side-menu-name: var(--blue-neutral-blue-20, #d0e0e9);\n  --side-menu-stroke: var(--grey-grey-60, #414141);\n  --side-menu-surface: var(--grey-grey-70, #2c2d31);\n  --side-menu-text-primary: var(--blue-neutral-blue-30, #c7cddd);\n  --side-menu-text-secondary: var(--grey-grey-40, #6b7682);\n  --tables-main-surface: var(--grey-grey-100, #181818);\n  --tables-pagination-pagination-active: var(--neutrals-neutral-80, #b6bbc7);\n  --tables-pagination-pagination-disabled: var(--dark-accent-blue-primary-disable, #799ba8);\n  --tables-photo-gallery-icon: var(--grey-grey-5, #e0e2e6);\n  --tables-photo-gallery-pagination-active: var(--dark-accent-bumblebee, #f0d980);\n  --tables-photo-gallery-pagination-default: var(--grey-grey-50, #797f89);\n  --tables-photo-gallery-surface: var(--grey-grey-80, #262626);\n  --tables-photo-gallery-surface-arrow: var(--grey-grey-90-2, #1f1f1fcc);\n  --tables-primary-row-icon: var(--grey-grey-5, #e0e2e6);\n  --tables-primary-row-stroke: var(--grey-grey-60, #414141);\n  --tables-primary-row-stroke-drag-drop: var(--dark-accent-blue-primary, #51d5ff);\n  --tables-primary-row-surface-default: var(--grey-grey-70, #2c2d31);\n  --tables-primary-row-surface-drag-drop: var(--dark-accent-blue-secondary, #044154);\n  --tables-primary-row-surface-hover: var(--yellow-yellow-90, #38362f);\n  --tables-primary-row-surface-selected: var(--grey-grey-60, #414141);\n  --tables-primary-row-text-additional: var(--grey-grey-50, #797f89);\n  --tables-primary-row-text-main: var(--neutrals-neutral-40, #f2f2f2);\n  --tables-secondary-row-sub-title-icon: var(--grey-grey-35, #a8acb7);\n  --tables-secondary-row-sub-title-surface: var(--grey-grey-85, #222222);\n  --tables-secondary-row-sub-title-text: var(--grey-grey-35, #a8acb7);\n  --tables-title-icon: var(--grey-grey-45, #6e7076);\n  --tables-title-progress-bar: var(--grey-grey-60, #414141);\n  --tables-title-stroke: var(--grey-grey-60, #414141);\n  --tables-title-surface: var(--grey-grey-80, #262626);\n  --tables-title-text: var(--grey-grey-5, #e0e2e6);\n  --tabs-stroke-default: var(--grey-grey-80, #262626);\n  --tabs-surface-active: var(--grey-grey-65, #343539);\n  --tabs-surface-default: var(--grey-grey-80, #27282b);\n  --tabs-surface-hover: var(--grey-grey-65, #343539);\n  --tabs-text-active: var(--neutrals-white, #ffffff);\n  --tabs-text-default: var(--grey-grey-30, #c4c9dd);\n  --tabs-text-disable: var(--grey-grey-40, #6b7682);\n  --tabs-text-hover: var(--neutrals-neutral-70, #d3d3d3);\n  --title-inputs-sections-drop-down-count: var(--blue-neutral-blue-50, #a8acb7);\n  --title-inputs-sections-required: var(--dark-accent-red-10, #f34b4b);\n  --title-inputs-sections-surface: var(--grey-grey-70, #2c2d31);\n  --title-inputs-sections-title: var(--grey-grey-35, #a8acb7);\n  --errors-and-states-green: var(--light-accent-green-20, #42ad7e);\n  --tables-skeleton-element: var(--grey-grey-60, #414141);\n  --tables-skeleton-surface-row-2: var(--grey-grey-55, #4a4a4a);\n  /*--GENERATED FROM PLUGIN--*/\n\n  --select-dropdown-box-shadow: 0px 1px 16px -1px rgba(0, 0, 0, 0.15), 1px 2px 8px -1px rgba(65, 65, 65, 0.4);\n  --modal-box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);\n  --basic-box-shadow: 0px 1px 16px -1px rgba(0, 0, 0, 0.15), 1px 2px 8px -1px rgba(65, 65, 65, 0.4);\n  --info-block-box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);\n  --file-preview-item-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);\n  --table-box-shadow: 0px -1px 0px 0px #414141 inset;\n  --map-legend-item-background-rgb: 52, 53, 57;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
